export default {
                   "age_names": {
                       "Castle Age": "4203",
                       "Dark Age": "4201",
                       "Feudal Age": "4202",
                       "Imperial Age": "4204"
                   },
                   "civ_helptexts": {
                       "Aztecs": "120164",
                       "Bengalis": "120190",
                       "Berbers": "120176",
                       "Bohemians": "120188",
                       "Britons": "120150",
                       "Bulgarians": "120181",
                       "Burgundians": "120185",
                       "Burmese": "120179",
                       "Byzantines": "120156",
                       "Celts": "120162",
                       "Chinese": "120155",
                       "Cumans": "120183",
                       "Dravidians": "120189",
                       "Ethiopians": "120174",
                       "Franks": "120151",
                       "Goths": "120152",
                       "Gurjaras": "120191",
                       "Hindustanis": "120169",
                       "Huns": "120166",
                       "Incas": "120170",
                       "Italians": "120168",
                       "Japanese": "120154",
                       "Khmer": "120177",
                       "Koreans": "120167",
                       "Lithuanians": "120184",
                       "Magyars": "120171",
                       "Malay": "120178",
                       "Malians": "120175",
                       "Mayans": "120165",
                       "Mongols": "120161",
                       "Persians": "120157",
                       "Poles": "120187",
                       "Portuguese": "120173",
                       "Saracens": "120158",
                       "Sicilians": "120186",
                       "Slavs": "120172",
                       "Spanish": "120163",
                       "Tatars": "120182",
                       "Teutons": "120153",
                       "Turks": "120159",
                       "Vietnamese": "120180",
                       "Vikings": "120160"
                   },
                   "civ_names": {
                       "Aztecs": "10285",
                       "Bengalis": "10311",
                       "Berbers": "10297",
                       "Bohemians": "10309",
                       "Britons": "10271",
                       "Bulgarians": "10302",
                       "Burgundians": "10306",
                       "Burmese": "10300",
                       "Byzantines": "10277",
                       "Celts": "10283",
                       "Chinese": "10276",
                       "Cumans": "10304",
                       "Dravidians": "10310",
                       "Ethiopians": "10295",
                       "Franks": "10272",
                       "Goths": "10273",
                       "Gurjaras": "10312",
                       "Hindustanis": "10290",
                       "Huns": "10287",
                       "Incas": "10291",
                       "Italians": "10289",
                       "Japanese": "10275",
                       "Khmer": "10298",
                       "Koreans": "10288",
                       "Lithuanians": "10305",
                       "Magyars": "10292",
                       "Malay": "10299",
                       "Malians": "10296",
                       "Mayans": "10286",
                       "Mongols": "10282",
                       "Persians": "10278",
                       "Poles": "10308",
                       "Portuguese": "10294",
                       "Saracens": "10279",
                       "Sicilians": "10307",
                       "Slavs": "10293",
                       "Spanish": "10284",
                       "Tatars": "10303",
                       "Teutons": "10274",
                       "Turks": "10280",
                       "Vietnamese": "10301",
                       "Vikings": "10281"
                   },
                   "data": {
                       "buildings": {
                           "12": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1200,
                               "ID": 12,
                               "LanguageHelpId": 26135,
                               "LanguageNameId": 5135,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 50,
                               "internal_name": "Barracks Age1"
                           },
                           "45": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 150
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1800,
                               "ID": 45,
                               "LanguageHelpId": 26144,
                               "LanguageNameId": 5144,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 2,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 35,
                               "internal_name": "DOCK"
                           },
                           "49": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 200
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1500,
                               "ID": 49,
                               "LanguageHelpId": 26169,
                               "LanguageNameId": 5169,
                               "LineOfSight": 6,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 40,
                               "internal_name": "SIWS"
                           },
                           "50": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 60
                               },
                               "GarrisonCapacity": 0,
                               "HP": 480,
                               "ID": 50,
                               "LanguageHelpId": 26149,
                               "LanguageNameId": 5149,
                               "LineOfSight": 1,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 15,
                               "internal_name": "FARM"
                           },
                           "68": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 100
                               },
                               "GarrisonCapacity": 0,
                               "HP": 600,
                               "ID": 68,
                               "LanguageHelpId": 26157,
                               "LanguageNameId": 5157,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 35,
                               "internal_name": "MILL"
                           },
                           "70": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 25
                               },
                               "GarrisonCapacity": 0,
                               "HP": 550,
                               "ID": 70,
                               "LanguageHelpId": 26344,
                               "LanguageNameId": 5344,
                               "LineOfSight": 2,
                               "MeleeArmor": -2,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 25,
                               "internal_name": "HOUS"
                           },
                           "71": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "Attacks": [
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   }
                               ],
                               "Cost": {
                                   "Stone": 100,
                                   "Wood": 275
                               },
                               "GarrisonCapacity": 15,
                               "HP": 2400,
                               "ID": 71,
                               "LanguageHelpId": 26164,
                               "LanguageNameId": 5164,
                               "LineOfSight": 8,
                               "MeleeArmor": 4,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 6,
                               "ReloadTime": 2,
                               "TrainTime": 100,
                               "internal_name": "RTWC2"
                           },
                           "72": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 3
                               },
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 72,
                               "LanguageHelpId": 26202,
                               "LanguageNameId": 5202,
                               "LineOfSight": 2,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 5,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 7,
                               "internal_name": "WALL"
                           },
                           "79": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 125,
                                   "Wood": 50
                               },
                               "GarrisonCapacity": 5,
                               "HP": 850,
                               "ID": 79,
                               "LanguageHelpId": 26178,
                               "LanguageNameId": 5178,
                               "LineOfSight": 10,
                               "MeleeArmor": 1,
                               "MinRange": 1,
                               "PierceArmor": 7,
                               "Range": 8,
                               "ReloadTime": 2,
                               "TrainTime": 80,
                               "internal_name": "WCTW"
                           },
                           "82": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 26
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 650,
                                   "Wood": 0
                               },
                               "GarrisonCapacity": 20,
                               "HP": 4800,
                               "ID": 82,
                               "LanguageHelpId": 26142,
                               "LanguageNameId": 5142,
                               "LineOfSight": 11,
                               "MeleeArmor": 8,
                               "MinRange": 1,
                               "PierceArmor": 11,
                               "Range": 8,
                               "ReloadTime": 2,
                               "TrainTime": 200,
                               "internal_name": "CSTL"
                           },
                           "84": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1800,
                               "ID": 84,
                               "LanguageHelpId": 26161,
                               "LanguageNameId": 5161,
                               "LineOfSight": 6,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 60,
                               "internal_name": "MRKT"
                           },
                           "87": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1500,
                               "ID": 87,
                               "LanguageHelpId": 26128,
                               "LanguageNameId": 5128,
                               "LineOfSight": 6,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 50,
                               "internal_name": "ARRG"
                           },
                           "101": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1500,
                               "ID": 101,
                               "LanguageHelpId": 26171,
                               "LanguageNameId": 5171,
                               "LineOfSight": 6,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 50,
                               "internal_name": "STBL"
                           },
                           "103": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 150
                               },
                               "GarrisonCapacity": 0,
                               "HP": 1800,
                               "ID": 103,
                               "LanguageHelpId": 26131,
                               "LanguageNameId": 5131,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 40,
                               "internal_name": "BLAC"
                           },
                           "104": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 10,
                               "HP": 2100,
                               "ID": 104,
                               "LanguageHelpId": 26138,
                               "LanguageNameId": 5138,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 40,
                               "internal_name": "CRCH"
                           },
                           "109": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "Attacks": [
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   }
                               ],
                               "Cost": {
                                   "Stone": 100,
                                   "Wood": 275
                               },
                               "GarrisonCapacity": 15,
                               "HP": 2400,
                               "ID": 109,
                               "LanguageHelpId": 26164,
                               "LanguageNameId": 5164,
                               "LineOfSight": 8,
                               "MeleeArmor": 3,
                               "MinRange": 0,
                               "PierceArmor": 5,
                               "Range": 6,
                               "ReloadTime": 2,
                               "TrainTime": 100,
                               "internal_name": "RTWC"
                           },
                           "117": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 5
                               },
                               "GarrisonCapacity": 0,
                               "HP": 1080,
                               "ID": 117,
                               "LanguageHelpId": 26203,
                               "LanguageNameId": 5203,
                               "LineOfSight": 2,
                               "MeleeArmor": 8,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 10,
                               "internal_name": "WALL2"
                           },
                           "155": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 24,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 5
                               },
                               "GarrisonCapacity": 0,
                               "HP": 3000,
                               "ID": 155,
                               "LanguageHelpId": 26204,
                               "LanguageNameId": 5204,
                               "LineOfSight": 2,
                               "MeleeArmor": 12,
                               "MinRange": 0,
                               "PierceArmor": 12,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 10,
                               "internal_name": "WALL3"
                           },
                           "199": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 100
                               },
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 199,
                               "LanguageHelpId": 26495,
                               "LanguageNameId": 5495,
                               "LineOfSight": 1,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 40,
                               "internal_name": "FTRAP"
                           },
                           "209": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 200
                               },
                               "GarrisonCapacity": 0,
                               "HP": 2100,
                               "ID": 209,
                               "LanguageHelpId": 26176,
                               "LanguageNameId": 5176,
                               "LineOfSight": 6,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 9,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 60,
                               "internal_name": "UNIV"
                           },
                           "234": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 125,
                                   "Wood": 50
                               },
                               "GarrisonCapacity": 5,
                               "HP": 1500,
                               "ID": 234,
                               "LanguageHelpId": 26154,
                               "LanguageNameId": 5154,
                               "LineOfSight": 10,
                               "MeleeArmor": 2,
                               "MinRange": 1,
                               "PierceArmor": 8,
                               "Range": 8,
                               "ReloadTime": 2,
                               "TrainTime": 80,
                               "internal_name": "WCTW2"
                           },
                           "235": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 125,
                                   "Wood": 50
                               },
                               "GarrisonCapacity": 5,
                               "HP": 2250,
                               "ID": 235,
                               "LanguageHelpId": 26155,
                               "LanguageNameId": 5155,
                               "LineOfSight": 10,
                               "MeleeArmor": 3,
                               "MinRange": 1,
                               "PierceArmor": 9,
                               "Range": 8,
                               "ReloadTime": 2,
                               "TrainTime": 80,
                               "internal_name": "WCTW3"
                           },
                           "236": {
                               "AccuracyPercent": 92,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 120,
                               "Attacks": [
                                   {
                                       "Amount": 40,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 120,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Gold": 100,
                                   "Stone": 125,
                                   "Wood": 0
                               },
                               "GarrisonCapacity": 5,
                               "HP": 2220,
                               "ID": 236,
                               "LanguageHelpId": 26156,
                               "LanguageNameId": 5156,
                               "LineOfSight": 10,
                               "MeleeArmor": 3,
                               "MinRange": 1,
                               "PierceArmor": 9,
                               "Range": 8,
                               "ReloadTime": 6,
                               "TrainTime": 80,
                               "internal_name": "WCTW4"
                           },
                           "276": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 0
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Gold": 1000,
                                   "Stone": 1000,
                                   "Wood": 1000
                               },
                               "GarrisonCapacity": 0,
                               "HP": 4800,
                               "ID": 276,
                               "LanguageHelpId": 26182,
                               "LanguageNameId": 5182,
                               "LineOfSight": 8,
                               "MeleeArmor": 3,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 3500,
                               "internal_name": "WNDR"
                           },
                           "487": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 30
                               },
                               "GarrisonCapacity": 0,
                               "HP": 1650,
                               "ID": 487,
                               "LanguageHelpId": 26185,
                               "LanguageNameId": 5185,
                               "LineOfSight": 6,
                               "MeleeArmor": 6,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 70,
                               "internal_name": "GTAX2"
                           },
                           "562": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 100
                               },
                               "GarrisonCapacity": 0,
                               "HP": 600,
                               "ID": 562,
                               "LanguageHelpId": 26464,
                               "LanguageNameId": 5464,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 35,
                               "internal_name": "SMIL"
                           },
                           "584": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 100
                               },
                               "GarrisonCapacity": 0,
                               "HP": 600,
                               "ID": 584,
                               "LanguageHelpId": 26487,
                               "LanguageNameId": 5487,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 35,
                               "internal_name": "MINE"
                           },
                           "598": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 5,
                                   "Wood": 25
                               },
                               "GarrisonCapacity": 0,
                               "HP": 500,
                               "ID": 598,
                               "LanguageHelpId": 26504,
                               "LanguageNameId": 5504,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 15,
                               "internal_name": "WCTWX"
                           },
                           "621": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 100,
                                   "Wood": 275
                               },
                               "GarrisonCapacity": 0,
                               "HP": 2400,
                               "ID": 621,
                               "LanguageHelpId": 26164,
                               "LanguageNameId": 5164,
                               "LineOfSight": 8,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 6,
                               "ReloadTime": 2,
                               "TrainTime": 150,
                               "internal_name": "RTWC1X"
                           },
                           "792": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 30
                               },
                               "GarrisonCapacity": 0,
                               "HP": 240,
                               "ID": 792,
                               "LanguageHelpId": 26186,
                               "LanguageNameId": 5186,
                               "LineOfSight": 6,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 30,
                               "internal_name": "PGTAX"
                           },
                           "1021": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Gold": 250,
                                   "Stone": 250
                               },
                               "GarrisonCapacity": 0,
                               "HP": 2700,
                               "ID": 1021,
                               "LanguageHelpId": 26159,
                               "LanguageNameId": 5159,
                               "LineOfSight": 6,
                               "MeleeArmor": 3,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 120,
                               "internal_name": "FEITO"
                           },
                           "1189": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Wood": 150
                               },
                               "GarrisonCapacity": 10,
                               "HP": 2000,
                               "ID": 1189,
                               "LanguageHelpId": 26249,
                               "LanguageNameId": 5249,
                               "LineOfSight": 10,
                               "MeleeArmor": 3,
                               "MinRange": 1,
                               "PierceArmor": 10,
                               "Range": 7,
                               "ReloadTime": 3,
                               "TrainTime": 35,
                               "internal_name": "HARBOR"
                           },
                           "1251": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 26
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 350
                               },
                               "GarrisonCapacity": 20,
                               "HP": 2600,
                               "ID": 1251,
                               "LanguageHelpId": 26349,
                               "LanguageNameId": 5349,
                               "LineOfSight": 10,
                               "MeleeArmor": 8,
                               "MinRange": 1,
                               "PierceArmor": 11,
                               "Range": 7,
                               "ReloadTime": 2,
                               "TrainTime": 150,
                               "internal_name": "KREPOST"
                           },
                           "1665": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 34
                                   }
                               ],
                               "Cost": {
                                   "Stone": 175,
                                   "Wood": 75
                               },
                               "GarrisonCapacity": 10,
                               "HP": 1250,
                               "ID": 1665,
                               "LanguageHelpId": 26544,
                               "LanguageNameId": 5544,
                               "LineOfSight": 10,
                               "MeleeArmor": 1,
                               "MinRange": 1,
                               "PierceArmor": 7,
                               "Range": 8,
                               "ReloadTime": 2,
                               "TrainTime": 90,
                               "internal_name": "DONJON"
                           },
                           "1734": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Wood": 125
                               },
                               "GarrisonCapacity": 0,
                               "HP": 1000,
                               "ID": 1734,
                               "LanguageHelpId": 26581,
                               "LanguageNameId": 5581,
                               "LineOfSight": 6,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 0,
                               "ReloadTime": 0,
                               "TrainTime": 40,
                               "internal_name": "FOLWARK1"
                           },
                           "1754": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "Attacks": [],
                               "Cost": {
                                   "Stone": 50,
                                   "Wood": 175
                               },
                               "GarrisonCapacity": 0,
                               "HP": 2700,
                               "ID": 1754,
                               "LanguageHelpId": 26440,
                               "LanguageNameId": 5440,
                               "LineOfSight": 6,
                               "MeleeArmor": 3,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 0,
                               "ReloadTime": 2.5,
                               "TrainTime": 60,
                               "internal_name": "CARAVANSERAI"
                           }
                       },
                       "techs": {
                           "3": {
                               "Cost": {
                                   "Gold": 450,
                                   "Wood": 750
                               },
                               "ID": 3,
                               "LanguageHelpId": 28419,
                               "LanguageNameId": 7419,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "British Yeoman"
                           },
                           "4": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 450
                               },
                               "ID": 4,
                               "LanguageHelpId": 28420,
                               "LanguageNameId": 7420,
                               "Repeatable": true,
                               "ResearchTime": 70,
                               "internal_name": "Mayan El Dorado"
                           },
                           "5": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 450
                               },
                               "ID": 5,
                               "LanguageHelpId": 28421,
                               "LanguageNameId": 7421,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Celtic Furor Celtica"
                           },
                           "6": {
                               "Cost": {
                                   "Gold": 450,
                                   "Wood": 500
                               },
                               "ID": 6,
                               "LanguageHelpId": 28422,
                               "LanguageNameId": 7422,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Mongol Siege Drill"
                           },
                           "7": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 7,
                               "LanguageHelpId": 28423,
                               "LanguageNameId": 7423,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Persian Mahouts"
                           },
                           "8": {
                               "Cost": {
                                   "Food": 75
                               },
                               "ID": 8,
                               "LanguageHelpId": 28008,
                               "LanguageNameId": 7008,
                               "Repeatable": false,
                               "ResearchTime": 25,
                               "internal_name": "Town Watch"
                           },
                           "9": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 450
                               },
                               "ID": 9,
                               "LanguageHelpId": 28424,
                               "LanguageNameId": 7424,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Saracen Zealotry"
                           },
                           "10": {
                               "Cost": {
                                   "Gold": 500,
                                   "Wood": 450
                               },
                               "ID": 10,
                               "LanguageHelpId": 28425,
                               "LanguageNameId": 7425,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Turkish Artillery"
                           },
                           "11": {
                               "Cost": {
                                   "Food": 600,
                                   "Stone": 400
                               },
                               "ID": 11,
                               "LanguageHelpId": 28426,
                               "LanguageNameId": 7426,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Teuton Crenellations"
                           },
                           "12": {
                               "Cost": {
                                   "Food": 250,
                                   "Wood": 250
                               },
                               "ID": 12,
                               "LanguageHelpId": 28012,
                               "LanguageNameId": 7012,
                               "Repeatable": true,
                               "ResearchTime": 70,
                               "internal_name": "Crop rotation"
                           },
                           "13": {
                               "Cost": {
                                   "Food": 125,
                                   "Wood": 125
                               },
                               "ID": 13,
                               "LanguageHelpId": 28013,
                               "LanguageNameId": 7013,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Heavy plow"
                           },
                           "14": {
                               "Cost": {
                                   "Food": 75,
                                   "Wood": 75
                               },
                               "ID": 14,
                               "LanguageHelpId": 28014,
                               "LanguageNameId": 7014,
                               "Repeatable": true,
                               "ResearchTime": 20,
                               "internal_name": "Horse collar"
                           },
                           "15": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 200
                               },
                               "ID": 15,
                               "LanguageHelpId": 28015,
                               "LanguageNameId": 7015,
                               "Repeatable": false,
                               "ResearchTime": 50,
                               "internal_name": "Guilds"
                           },
                           "16": {
                               "Cost": {
                                   "Food": 450,
                                   "Gold": 250
                               },
                               "ID": 16,
                               "LanguageHelpId": 28427,
                               "LanguageNameId": 7427,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Gothic Anarchy"
                           },
                           "17": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 200
                               },
                               "ID": 17,
                               "LanguageHelpId": 28017,
                               "LanguageNameId": 7017,
                               "Repeatable": false,
                               "ResearchTime": 70,
                               "internal_name": "Banking"
                           },
                           "19": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 0
                               },
                               "ID": 19,
                               "LanguageHelpId": 28019,
                               "LanguageNameId": 7019,
                               "Repeatable": true,
                               "ResearchTime": 1,
                               "internal_name": "Cartography"
                           },
                           "21": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 500
                               },
                               "ID": 21,
                               "LanguageHelpId": 28428,
                               "LanguageNameId": 7428,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Hun Atheism"
                           },
                           "22": {
                               "Cost": {
                                   "Gold": 50
                               },
                               "ID": 22,
                               "LanguageHelpId": 28022,
                               "LanguageNameId": 7022,
                               "Repeatable": true,
                               "ResearchTime": 25,
                               "internal_name": "Loom"
                           },
                           "23": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 100
                               },
                               "ID": 23,
                               "LanguageHelpId": 28023,
                               "LanguageNameId": 7023,
                               "Repeatable": false,
                               "ResearchTime": 70,
                               "internal_name": "Coinage"
                           },
                           "24": {
                               "Cost": {
                                   "Food": 450,
                                   "Gold": 750
                               },
                               "ID": 24,
                               "LanguageHelpId": 28429,
                               "LanguageNameId": 7429,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Aztec Garland Wars"
                           },
                           "39": {
                               "Cost": {
                                   "Food": 150
                               },
                               "ID": 39,
                               "LanguageHelpId": 28039,
                               "LanguageNameId": 7039,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Husbandry"
                           },
                           "45": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 1000
                               },
                               "ID": 45,
                               "LanguageHelpId": 28045,
                               "LanguageNameId": 7045,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Faith"
                           },
                           "47": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 200
                               },
                               "ID": 47,
                               "LanguageHelpId": 28047,
                               "LanguageNameId": 7047,
                               "Repeatable": true,
                               "ResearchTime": 100,
                               "internal_name": "Chemistry"
                           },
                           "48": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 200
                               },
                               "ID": 48,
                               "LanguageHelpId": 28410,
                               "LanguageNameId": 7410,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Caravan"
                           },
                           "49": {
                               "Cost": {
                                   "Food": 850,
                                   "Gold": 400
                               },
                               "ID": 49,
                               "LanguageHelpId": 28431,
                               "LanguageNameId": 7431,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Viking Berserkergang"
                           },
                           "50": {
                               "Cost": {
                                   "Food": 150,
                                   "Wood": 175
                               },
                               "ID": 50,
                               "LanguageHelpId": 28050,
                               "LanguageNameId": 7050,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Masonry"
                           },
                           "51": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 200
                               },
                               "ID": 51,
                               "LanguageHelpId": 28051,
                               "LanguageNameId": 7051,
                               "Repeatable": true,
                               "ResearchTime": 70,
                               "internal_name": "Architecture"
                           },
                           "52": {
                               "Cost": {
                                   "Gold": 750,
                                   "Wood": 750
                               },
                               "ID": 52,
                               "LanguageHelpId": 28432,
                               "LanguageNameId": 7432,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Chinese Rocketry"
                           },
                           "54": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 200
                               },
                               "ID": 54,
                               "LanguageHelpId": 28054,
                               "LanguageNameId": 7054,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Stone cutting"
                           },
                           "55": {
                               "Cost": {
                                   "Food": 100,
                                   "Wood": 75
                               },
                               "ID": 55,
                               "LanguageHelpId": 28055,
                               "LanguageNameId": 7055,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Gold Mining"
                           },
                           "59": {
                               "Cost": {
                                   "Gold": 400,
                                   "Wood": 750
                               },
                               "ID": 59,
                               "LanguageHelpId": 28059,
                               "LanguageNameId": 7059,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Japanese Kataparuto"
                           },
                           "61": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 600
                               },
                               "ID": 61,
                               "LanguageHelpId": 28318,
                               "LanguageNameId": 7318,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Byzantine Logistica"
                           },
                           "63": {
                               "Cost": {
                                   "Food": 500,
                                   "Wood": 350
                               },
                               "ID": 63,
                               "LanguageHelpId": 28063,
                               "LanguageNameId": 7063,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Keep"
                           },
                           "64": {
                               "Cost": {
                                   "Food": 800,
                                   "Wood": 400
                               },
                               "ID": 64,
                               "LanguageHelpId": 28320,
                               "LanguageNameId": 7320,
                               "Repeatable": false,
                               "ResearchTime": 60,
                               "internal_name": "Bombard Tower"
                           },
                           "65": {
                               "Cost": {
                                   "Food": 150,
                                   "Wood": 200
                               },
                               "ID": 65,
                               "LanguageHelpId": 28314,
                               "LanguageNameId": 7314,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Gillnets"
                           },
                           "67": {
                               "Cost": {
                                   "Food": 150
                               },
                               "ID": 67,
                               "LanguageHelpId": 28067,
                               "LanguageNameId": 7067,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Forging"
                           },
                           "68": {
                               "Cost": {
                                   "Food": 220,
                                   "Gold": 120
                               },
                               "ID": 68,
                               "LanguageHelpId": 28068,
                               "LanguageNameId": 7068,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Iron casting"
                           },
                           "74": {
                               "Cost": {
                                   "Food": 100
                               },
                               "ID": 74,
                               "LanguageHelpId": 28074,
                               "LanguageNameId": 7074,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Scale Mail Armor"
                           },
                           "75": {
                               "Cost": {
                                   "Food": 275,
                                   "Gold": 225
                               },
                               "ID": 75,
                               "LanguageHelpId": 28075,
                               "LanguageNameId": 7075,
                               "Repeatable": true,
                               "ResearchTime": 100,
                               "internal_name": "Blast Furnace"
                           },
                           "76": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 100
                               },
                               "ID": 76,
                               "LanguageHelpId": 28076,
                               "LanguageNameId": 7076,
                               "Repeatable": true,
                               "ResearchTime": 55,
                               "internal_name": "Chain Mail Armor"
                           },
                           "77": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 150
                               },
                               "ID": 77,
                               "LanguageHelpId": 28077,
                               "LanguageNameId": 7077,
                               "Repeatable": true,
                               "ResearchTime": 70,
                               "internal_name": "Plate Mail Armor"
                           },
                           "80": {
                               "Cost": {
                                   "Food": 350,
                                   "Gold": 200
                               },
                               "ID": 80,
                               "LanguageHelpId": 28080,
                               "LanguageNameId": 7080,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Plate Barding Armor"
                           },
                           "81": {
                               "Cost": {
                                   "Food": 150
                               },
                               "ID": 81,
                               "LanguageHelpId": 28081,
                               "LanguageNameId": 7081,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Scale Barding Armor"
                           },
                           "82": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 150
                               },
                               "ID": 82,
                               "LanguageHelpId": 28082,
                               "LanguageNameId": 7082,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Chain Barding Armor"
                           },
                           "83": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 83,
                               "LanguageHelpId": 28324,
                               "LanguageNameId": 7324,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Frankish Bearded Axe"
                           },
                           "90": {
                               "Cost": {},
                               "ID": 90,
                               "LanguageHelpId": 28090,
                               "LanguageNameId": 7090,
                               "Repeatable": true,
                               "ResearchTime": 0,
                               "internal_name": "Tracking"
                           },
                           "93": {
                               "Cost": {
                                   "Gold": 175,
                                   "Wood": 300
                               },
                               "ID": 93,
                               "LanguageHelpId": 28093,
                               "LanguageNameId": 7093,
                               "Repeatable": false,
                               "ResearchTime": 60,
                               "internal_name": "Ballistics"
                           },
                           "101": {
                               "Cost": {
                                   "Food": 500
                               },
                               "ID": 101,
                               "LanguageHelpId": 28101,
                               "LanguageNameId": 7101,
                               "Repeatable": false,
                               "ResearchTime": 130,
                               "internal_name": "Middle Age"
                           },
                           "102": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 200
                               },
                               "ID": 102,
                               "LanguageHelpId": 28102,
                               "LanguageNameId": 7102,
                               "Repeatable": false,
                               "ResearchTime": 160,
                               "internal_name": "Feudal Age"
                           },
                           "103": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 800
                               },
                               "ID": 103,
                               "LanguageHelpId": 28103,
                               "LanguageNameId": 7103,
                               "Repeatable": false,
                               "ResearchTime": 190,
                               "internal_name": "Imperial Age"
                           },
                           "140": {
                               "Cost": {
                                   "Food": 100,
                                   "Wood": 250
                               },
                               "ID": 140,
                               "LanguageHelpId": 28186,
                               "LanguageNameId": 7186,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Guard Tower"
                           },
                           "182": {
                               "Cost": {
                                   "Food": 200,
                                   "Wood": 150
                               },
                               "ID": 182,
                               "LanguageHelpId": 28180,
                               "LanguageNameId": 7180,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Gold Shaft Mining"
                           },
                           "194": {
                               "Cost": {
                                   "Food": 200,
                                   "Wood": 100
                               },
                               "ID": 194,
                               "LanguageHelpId": 28163,
                               "LanguageNameId": 7163,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Fortified Wall"
                           },
                           "199": {
                               "Cost": {
                                   "Food": 100,
                                   "Gold": 50
                               },
                               "ID": 199,
                               "LanguageHelpId": 28172,
                               "LanguageNameId": 7172,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Fletching"
                           },
                           "200": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 100
                               },
                               "ID": 200,
                               "LanguageHelpId": 28150,
                               "LanguageNameId": 7150,
                               "Repeatable": true,
                               "ResearchTime": 35,
                               "internal_name": "Bodkin Arrow"
                           },
                           "201": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 200
                               },
                               "ID": 201,
                               "LanguageHelpId": 28151,
                               "LanguageNameId": 7151,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Bracer"
                           },
                           "202": {
                               "Cost": {
                                   "Food": 100,
                                   "Wood": 50
                               },
                               "ID": 202,
                               "LanguageHelpId": 28189,
                               "LanguageNameId": 7189,
                               "Repeatable": true,
                               "ResearchTime": 25,
                               "internal_name": "Double Bit Axe"
                           },
                           "203": {
                               "Cost": {
                                   "Food": 150,
                                   "Wood": 100
                               },
                               "ID": 203,
                               "LanguageHelpId": 28190,
                               "LanguageNameId": 7190,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Bow Saw"
                           },
                           "211": {
                               "Cost": {
                                   "Food": 100
                               },
                               "ID": 211,
                               "LanguageHelpId": 28208,
                               "LanguageNameId": 7208,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Padded Archer Armor"
                           },
                           "212": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 150
                               },
                               "ID": 212,
                               "LanguageHelpId": 28209,
                               "LanguageNameId": 7209,
                               "Repeatable": true,
                               "ResearchTime": 55,
                               "internal_name": "Leather Archer Armor"
                           },
                           "213": {
                               "Cost": {
                                   "Food": 175,
                                   "Wood": 50
                               },
                               "ID": 213,
                               "LanguageHelpId": 28211,
                               "LanguageNameId": 7211,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Wheel Barrow"
                           },
                           "215": {
                               "Cost": {
                                   "Food": 100
                               },
                               "ID": 215,
                               "LanguageHelpId": 28210,
                               "LanguageNameId": 7210,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Squires"
                           },
                           "219": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 250
                               },
                               "ID": 219,
                               "LanguageHelpId": 28216,
                               "LanguageNameId": 7216,
                               "Repeatable": true,
                               "ResearchTime": 70,
                               "internal_name": "Ring Archer Armor"
                           },
                           "221": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 200
                               },
                               "ID": 221,
                               "LanguageHelpId": 28231,
                               "LanguageNameId": 7231,
                               "Repeatable": true,
                               "ResearchTime": 100,
                               "internal_name": "Two Man Saw"
                           },
                           "230": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 200
                               },
                               "ID": 230,
                               "LanguageHelpId": 28222,
                               "LanguageNameId": 7222,
                               "Repeatable": true,
                               "ResearchTime": 55,
                               "internal_name": "Block Printing"
                           },
                           "231": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 120
                               },
                               "ID": 231,
                               "LanguageHelpId": 28221,
                               "LanguageNameId": 7221,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Sanctity"
                           },
                           "233": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 120
                               },
                               "ID": 233,
                               "LanguageHelpId": 28220,
                               "LanguageNameId": 7220,
                               "Repeatable": true,
                               "ResearchTime": 65,
                               "internal_name": "Illumination"
                           },
                           "249": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 200
                               },
                               "ID": 249,
                               "LanguageHelpId": 28246,
                               "LanguageNameId": 7246,
                               "Repeatable": true,
                               "ResearchTime": 55,
                               "internal_name": "Hand Cart"
                           },
                           "252": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 140
                               },
                               "ID": 252,
                               "LanguageHelpId": 28249,
                               "LanguageNameId": 7249,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Fervor"
                           },
                           "278": {
                               "Cost": {
                                   "Food": 100,
                                   "Wood": 75
                               },
                               "ID": 278,
                               "LanguageHelpId": 28276,
                               "LanguageNameId": 7276,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Stone Mining"
                           },
                           "279": {
                               "Cost": {
                                   "Food": 200,
                                   "Wood": 150
                               },
                               "ID": 279,
                               "LanguageHelpId": 28277,
                               "LanguageNameId": 7277,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Stone Shaft Mining"
                           },
                           "280": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 100
                               },
                               "ID": 280,
                               "LanguageHelpId": 28282,
                               "LanguageNameId": 7282,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Town Patrol"
                           },
                           "315": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 150
                               },
                               "ID": 315,
                               "LanguageHelpId": 28319,
                               "LanguageNameId": 7319,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Conscription"
                           },
                           "316": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 475
                               },
                               "ID": 316,
                               "LanguageHelpId": 28315,
                               "LanguageNameId": 7315,
                               "Repeatable": false,
                               "ResearchTime": 50,
                               "internal_name": "Redemption"
                           },
                           "319": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 325
                               },
                               "ID": 319,
                               "LanguageHelpId": 28316,
                               "LanguageNameId": 7316,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Atonement"
                           },
                           "321": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 200
                               },
                               "ID": 321,
                               "LanguageHelpId": 28322,
                               "LanguageNameId": 7322,
                               "Repeatable": true,
                               "ResearchTime": 10,
                               "internal_name": "Sappers"
                           },
                           "322": {
                               "Cost": {
                                   "Food": 200,
                                   "Stone": 100
                               },
                               "ID": 322,
                               "LanguageHelpId": 28321,
                               "LanguageNameId": 7321,
                               "Repeatable": false,
                               "ResearchTime": 60,
                               "internal_name": "Murder Holes"
                           },
                           "373": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 300
                               },
                               "ID": 373,
                               "LanguageHelpId": 28377,
                               "LanguageNameId": 7377,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Shipwright"
                           },
                           "374": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 150
                               },
                               "ID": 374,
                               "LanguageHelpId": 28372,
                               "LanguageNameId": 7372,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Careening"
                           },
                           "375": {
                               "Cost": {
                                   "Food": 600,
                                   "Gold": 400
                               },
                               "ID": 375,
                               "LanguageHelpId": 28373,
                               "LanguageNameId": 7373,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Dry Dock"
                           },
                           "377": {
                               "Cost": {
                                   "Food": 500,
                                   "Wood": 600
                               },
                               "ID": 377,
                               "LanguageHelpId": 28378,
                               "LanguageNameId": 7378,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Siege Engineers"
                           },
                           "379": {
                               "Cost": {
                                   "Food": 400,
                                   "Wood": 400
                               },
                               "ID": 379,
                               "LanguageHelpId": 28376,
                               "LanguageNameId": 7376,
                               "Repeatable": true,
                               "ResearchTime": 75,
                               "internal_name": "Hoardings"
                           },
                           "380": {
                               "Cost": {
                                   "Food": 350,
                                   "Gold": 100
                               },
                               "ID": 380,
                               "LanguageHelpId": 28374,
                               "LanguageNameId": 7374,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Heated Shot"
                           },
                           "408": {
                               "Cost": {
                                   "Gold": 200
                               },
                               "ID": 408,
                               "LanguageHelpId": 28408,
                               "LanguageNameId": 7408,
                               "Repeatable": false,
                               "ResearchTime": 1,
                               "internal_name": "Spy Technology"
                           },
                           "435": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 100
                               },
                               "ID": 435,
                               "LanguageHelpId": 28409,
                               "LanguageNameId": 7409,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Bloodlines"
                           },
                           "436": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 250
                               },
                               "ID": 436,
                               "LanguageHelpId": 28415,
                               "LanguageNameId": 7415,
                               "Repeatable": true,
                               "ResearchTime": 65,
                               "internal_name": "Parthian Tactics"
                           },
                           "437": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 250
                               },
                               "ID": 437,
                               "LanguageHelpId": 28411,
                               "LanguageNameId": 7411,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Thumb Ring"
                           },
                           "438": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 200
                               },
                               "ID": 438,
                               "LanguageHelpId": 28416,
                               "LanguageNameId": 7416,
                               "Repeatable": false,
                               "ResearchTime": 75,
                               "internal_name": "Theocracy"
                           },
                           "439": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 1000
                               },
                               "ID": 439,
                               "LanguageHelpId": 28412,
                               "LanguageNameId": 7412,
                               "Repeatable": false,
                               "ResearchTime": 60,
                               "internal_name": "Heresy"
                           },
                           "440": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 250
                               },
                               "ID": 440,
                               "LanguageHelpId": 28325,
                               "LanguageNameId": 7325,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Spanish Supremacy"
                           },
                           "441": {
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 200
                               },
                               "ID": 441,
                               "LanguageHelpId": 28435,
                               "LanguageNameId": 7435,
                               "Repeatable": true,
                               "ResearchTime": 35,
                               "internal_name": "Herbal Medicine"
                           },
                           "445": {
                               "Cost": {
                                   "Gold": 500,
                                   "Wood": 800
                               },
                               "ID": 445,
                               "LanguageHelpId": 28438,
                               "LanguageNameId": 7438,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Korean catapults"
                           },
                           "454": {
                               "Cost": {
                                   "Food": 650,
                                   "Gold": 500
                               },
                               "ID": 454,
                               "LanguageHelpId": 28447,
                               "LanguageNameId": 7447,
                               "Repeatable": true,
                               "ResearchTime": 50,
                               "internal_name": "Counterweights"
                           },
                           "455": {
                               "Cost": {
                                   "Gold": 200,
                                   "Wood": 400
                               },
                               "ID": 455,
                               "LanguageHelpId": 28448,
                               "LanguageNameId": 7448,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Detinets"
                           },
                           "457": {
                               "Cost": {
                                   "Gold": 600,
                                   "Wood": 400
                               },
                               "ID": 457,
                               "LanguageHelpId": 28439,
                               "LanguageNameId": 7439,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Gothic Perfusion"
                           },
                           "460": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 350
                               },
                               "ID": 460,
                               "LanguageHelpId": 28326,
                               "LanguageNameId": 7326,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Aztec Sacrifice"
                           },
                           "461": {
                               "Cost": {
                                   "Gold": 400,
                                   "Wood": 800
                               },
                               "ID": 461,
                               "LanguageHelpId": 28327,
                               "LanguageNameId": 7327,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Britons City Rights"
                           },
                           "462": {
                               "Cost": {
                                   "Stone": 200,
                                   "Wood": 400
                               },
                               "ID": 462,
                               "LanguageHelpId": 28368,
                               "LanguageNameId": 7368,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Chinese Great Wall"
                           },
                           "463": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 500
                               },
                               "ID": 463,
                               "LanguageHelpId": 28312,
                               "LanguageNameId": 7312,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Viking Chieftains"
                           },
                           "464": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 300
                               },
                               "ID": 464,
                               "LanguageHelpId": 28313,
                               "LanguageNameId": 7313,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Byzantines Greek Fire"
                           },
                           "482": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 200
                               },
                               "ID": 482,
                               "LanguageHelpId": 28369,
                               "LanguageNameId": 7369,
                               "Repeatable": true,
                               "ResearchTime": 30,
                               "internal_name": "Stronghold"
                           },
                           "483": {
                               "Cost": {
                                   "Gold": 200,
                                   "Wood": 300
                               },
                               "ID": 483,
                               "LanguageHelpId": 28370,
                               "LanguageNameId": 7370,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Huns UT"
                           },
                           "484": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 300
                               },
                               "ID": 484,
                               "LanguageHelpId": 28371,
                               "LanguageNameId": 7371,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Japanese UT"
                           },
                           "485": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 485,
                               "LanguageHelpId": 28379,
                               "LanguageNameId": 7379,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Mayans UT"
                           },
                           "486": {
                               "Cost": {
                                   "Food": 300,
                                   "Wood": 300
                               },
                               "ID": 486,
                               "LanguageHelpId": 28380,
                               "LanguageNameId": 7380,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Koreans UT"
                           },
                           "487": {
                               "Cost": {
                                   "Gold": 150,
                                   "Wood": 300
                               },
                               "ID": 487,
                               "LanguageHelpId": 28280,
                               "LanguageNameId": 7280,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Mongols UT"
                           },
                           "488": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 300
                               },
                               "ID": 488,
                               "LanguageHelpId": 28281,
                               "LanguageNameId": 7281,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Persians UT"
                           },
                           "489": {
                               "Cost": {
                                   "Gold": 350,
                                   "Wood": 400
                               },
                               "ID": 489,
                               "LanguageHelpId": 28283,
                               "LanguageNameId": 7283,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Teutons UT"
                           },
                           "491": {
                               "Cost": {
                                   "Food": 350,
                                   "Gold": 150
                               },
                               "ID": 491,
                               "LanguageHelpId": 28285,
                               "LanguageNameId": 7285,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Sipahi"
                           },
                           "492": {
                               "Cost": {
                                   "Food": 100,
                                   "Gold": 300
                               },
                               "ID": 492,
                               "LanguageHelpId": 28286,
                               "LanguageNameId": 7286,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Spanish UT"
                           },
                           "493": {
                               "Cost": {
                                   "Gold": 500,
                                   "Wood": 600
                               },
                               "ID": 493,
                               "LanguageHelpId": 28287,
                               "LanguageNameId": 7287,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Franks UT"
                           },
                           "494": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 150
                               },
                               "ID": 494,
                               "LanguageHelpId": 28272,
                               "LanguageNameId": 7272,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Pavise"
                           },
                           "499": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 250
                               },
                               "ID": 499,
                               "LanguageHelpId": 28273,
                               "LanguageNameId": 7273,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Silk Route"
                           },
                           "506": {
                               "Cost": {
                                   "Food": 400,
                                   "Wood": 400
                               },
                               "ID": 506,
                               "LanguageHelpId": 28270,
                               "LanguageNameId": 7270,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Indians UT"
                           },
                           "507": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 300
                               },
                               "ID": 507,
                               "LanguageHelpId": 28271,
                               "LanguageNameId": 7271,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Indians UT2"
                           },
                           "513": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 500
                               },
                               "ID": 513,
                               "LanguageHelpId": 28269,
                               "LanguageNameId": 7269,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Slavs UT"
                           },
                           "514": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 300
                               },
                               "ID": 514,
                               "LanguageHelpId": 28275,
                               "LanguageNameId": 7275,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Magyars UT"
                           },
                           "515": {
                               "Cost": {
                                   "Gold": 400,
                                   "Wood": 600
                               },
                               "ID": 515,
                               "LanguageHelpId": 28274,
                               "LanguageNameId": 7274,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Indians UT"
                           },
                           "516": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 300
                               },
                               "ID": 516,
                               "LanguageHelpId": 28266,
                               "LanguageNameId": 7266,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Incas UT"
                           },
                           "517": {
                               "Cost": {
                                   "Food": 600,
                                   "Gold": 600
                               },
                               "ID": 517,
                               "LanguageHelpId": 28267,
                               "LanguageNameId": 7267,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Indians UT"
                           },
                           "572": {
                               "Cost": {
                                   "Gold": 300,
                                   "Wood": 200
                               },
                               "ID": 572,
                               "LanguageHelpId": 28250,
                               "LanguageNameId": 7250,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Portuguese UT"
                           },
                           "573": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 400
                               },
                               "ID": 573,
                               "LanguageHelpId": 28251,
                               "LanguageNameId": 7251,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Portuguese UT"
                           },
                           "574": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 574,
                               "LanguageHelpId": 28252,
                               "LanguageNameId": 7252,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Ethiopian UT"
                           },
                           "575": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 600
                               },
                               "ID": 575,
                               "LanguageHelpId": 28253,
                               "LanguageNameId": 7253,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Ethiopian UT"
                           },
                           "576": {
                               "Cost": {
                                   "Food": 200,
                                   "Wood": 300
                               },
                               "ID": 576,
                               "LanguageHelpId": 28254,
                               "LanguageNameId": 7254,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Malian UT"
                           },
                           "577": {
                               "Cost": {
                                   "Food": 650,
                                   "Gold": 400
                               },
                               "ID": 577,
                               "LanguageHelpId": 28255,
                               "LanguageNameId": 7255,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Malian UT"
                           },
                           "578": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 250
                               },
                               "ID": 578,
                               "LanguageHelpId": 28256,
                               "LanguageNameId": 7256,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Berber UT"
                           },
                           "579": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 300
                               },
                               "ID": 579,
                               "LanguageHelpId": 28257,
                               "LanguageNameId": 7257,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Berber UT"
                           },
                           "602": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 50
                               },
                               "ID": 602,
                               "LanguageHelpId": 28258,
                               "LanguageNameId": 7258,
                               "Repeatable": true,
                               "ResearchTime": 25,
                               "internal_name": "Arson"
                           },
                           "608": {
                               "Cost": {
                                   "Food": 250,
                                   "Wood": 250
                               },
                               "ID": 608,
                               "LanguageHelpId": 28278,
                               "LanguageNameId": 7278,
                               "Repeatable": true,
                               "ResearchTime": 25,
                               "internal_name": "Arrowslits"
                           },
                           "622": {
                               "Cost": {
                                   "Gold": 450,
                                   "Wood": 300
                               },
                               "ID": 622,
                               "LanguageHelpId": 28291,
                               "LanguageNameId": 7291,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Khmer UT"
                           },
                           "623": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 400
                               },
                               "ID": 623,
                               "LanguageHelpId": 28292,
                               "LanguageNameId": 7292,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Khmer UT"
                           },
                           "624": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 624,
                               "LanguageHelpId": 28293,
                               "LanguageNameId": 7293,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Malay UT"
                           },
                           "625": {
                               "Cost": {
                                   "Food": 850,
                                   "Gold": 500
                               },
                               "ID": 625,
                               "LanguageHelpId": 28294,
                               "LanguageNameId": 7294,
                               "Repeatable": false,
                               "ResearchTime": 40,
                               "internal_name": "Malay UT"
                           },
                           "626": {
                               "Cost": {
                                   "Food": 400,
                                   "Wood": 300
                               },
                               "ID": 626,
                               "LanguageHelpId": 28295,
                               "LanguageNameId": 7295,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Burmese UT"
                           },
                           "627": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 400
                               },
                               "ID": 627,
                               "LanguageHelpId": 28296,
                               "LanguageNameId": 7296,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Burmese UT"
                           },
                           "628": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 250
                               },
                               "ID": 628,
                               "LanguageHelpId": 28297,
                               "LanguageNameId": 7297,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Vietnamese UT"
                           },
                           "629": {
                               "Cost": {
                                   "Gold": 350,
                                   "Wood": 600
                               },
                               "ID": 629,
                               "LanguageHelpId": 28298,
                               "LanguageNameId": 7298,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Vietnamese UT"
                           },
                           "685": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 200
                               },
                               "ID": 685,
                               "LanguageHelpId": 28307,
                               "LanguageNameId": 7307,
                               "Repeatable": true,
                               "ResearchTime": 35,
                               "internal_name": "Khmer UT"
                           },
                           "686": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 450
                               },
                               "ID": 686,
                               "LanguageHelpId": 28308,
                               "LanguageNameId": 7308,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Khmer UT"
                           },
                           "687": {
                               "Cost": {
                                   "Gold": 300,
                                   "Wood": 400
                               },
                               "ID": 687,
                               "LanguageHelpId": 28309,
                               "LanguageNameId": 7309,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Malay UT"
                           },
                           "688": {
                               "Cost": {
                                   "Gold": 400,
                                   "Wood": 500
                               },
                               "ID": 688,
                               "LanguageHelpId": 28310,
                               "LanguageNameId": 7310,
                               "Repeatable": false,
                               "ResearchTime": 50,
                               "internal_name": "Malay UT"
                           },
                           "689": {
                               "Cost": {
                                   "Food": 200,
                                   "Wood": 300
                               },
                               "ID": 689,
                               "LanguageHelpId": 28311,
                               "LanguageNameId": 7311,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Burmese UT"
                           },
                           "690": {
                               "Cost": {
                                   "Food": 650,
                                   "Gold": 400
                               },
                               "ID": 690,
                               "LanguageHelpId": 28398,
                               "LanguageNameId": 7398,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Burmese UT"
                           },
                           "691": {
                               "Cost": {
                                   "Food": 250,
                                   "Gold": 250
                               },
                               "ID": 691,
                               "LanguageHelpId": 28399,
                               "LanguageNameId": 7399,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Vietnamese UT"
                           },
                           "692": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 200
                               },
                               "ID": 692,
                               "LanguageHelpId": 28400,
                               "LanguageNameId": 7400,
                               "Repeatable": true,
                               "ResearchTime": 40,
                               "internal_name": "Vietnamese UT"
                           },
                           "716": {
                               "Cost": {
                                   "Food": 75,
                                   "Gold": 75
                               },
                               "ID": 716,
                               "LanguageHelpId": 28403,
                               "LanguageNameId": 7403,
                               "Repeatable": false,
                               "ResearchTime": 35,
                               "internal_name": "Tracking"
                           },
                           "754": {
                               "Cost": {
                                   "Food": 400,
                                   "Gold": 300
                               },
                               "ID": 754,
                               "LanguageHelpId": 28342,
                               "LanguageNameId": 7342,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Burgundian Vineyards"
                           },
                           "755": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 650
                               },
                               "ID": 755,
                               "LanguageHelpId": 28343,
                               "LanguageNameId": 7343,
                               "Repeatable": true,
                               "ResearchTime": 10,
                               "internal_name": "Flemish Revolution"
                           },
                           "756": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 600
                               },
                               "ID": 756,
                               "LanguageHelpId": 28344,
                               "LanguageNameId": 7344,
                               "Repeatable": false,
                               "ResearchTime": 60,
                               "internal_name": "First Crusade"
                           },
                           "757": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 600
                               },
                               "ID": 757,
                               "LanguageHelpId": 28345,
                               "LanguageNameId": 7345,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Hauberk"
                           },
                           "782": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 300
                               },
                               "ID": 782,
                               "LanguageHelpId": 28348,
                               "LanguageNameId": 7348,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Szlachta Privileges"
                           },
                           "783": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 550
                               },
                               "ID": 783,
                               "LanguageHelpId": 28349,
                               "LanguageNameId": 7349,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Lechitic Legacy"
                           },
                           "784": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 784,
                               "LanguageHelpId": 28350,
                               "LanguageNameId": 7350,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Wagenburg Tactics"
                           },
                           "785": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 450
                               },
                               "ID": 785,
                               "LanguageHelpId": 28351,
                               "LanguageNameId": 7351,
                               "Repeatable": false,
                               "ResearchTime": 45,
                               "internal_name": "Hussite Reforms"
                           },
                           "831": {
                               "Cost": {
                                   "Food": 350,
                                   "Gold": 250
                               },
                               "ID": 831,
                               "LanguageHelpId": 28357,
                               "LanguageNameId": 7357,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Medical Corps"
                           },
                           "832": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 600
                               },
                               "ID": 832,
                               "LanguageHelpId": 28358,
                               "LanguageNameId": 7358,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Wootz Steel"
                           },
                           "833": {
                               "Cost": {
                                   "Gold": 275,
                                   "Wood": 375
                               },
                               "ID": 833,
                               "LanguageHelpId": 28359,
                               "LanguageNameId": 7359,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Paiks"
                           },
                           "834": {
                               "Cost": {
                                   "Gold": 650,
                                   "Wood": 800
                               },
                               "ID": 834,
                               "LanguageHelpId": 28360,
                               "LanguageNameId": 7360,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Mahayana"
                           },
                           "835": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 400
                               },
                               "ID": 835,
                               "LanguageHelpId": 28361,
                               "LanguageNameId": 7361,
                               "Repeatable": true,
                               "ResearchTime": 45,
                               "internal_name": "Kshatriyas"
                           },
                           "836": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 700
                               },
                               "ID": 836,
                               "LanguageHelpId": 28362,
                               "LanguageNameId": 7362,
                               "Repeatable": true,
                               "ResearchTime": 60,
                               "internal_name": "Frontier Guards"
                           }
                       },
                       "unit_upgrades": {
                           "6": {
                               "Cost": {
                                   "Gold": 130,
                                   "Wood": 230
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Skirmisher"
                           },
                           "21": {
                               "Cost": {
                                   "Food": 230,
                                   "Gold": 100
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "War Galley"
                           },
                           "24": {
                               "Cost": {
                                   "Food": 175,
                                   "Gold": 125
                               },
                               "ID": 901,
                               "ResearchTime": 35,
                               "internal_name": "Crossbow"
                           },
                           "75": {
                               "Cost": {
                                   "Food": 100,
                                   "Gold": 40
                               },
                               "ID": 901,
                               "ResearchTime": 40,
                               "internal_name": "Man-At-Arms"
                           },
                           "77": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 65
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Long Swordsman"
                           },
                           "207": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 125,
                               "internal_name": "Heavy Camel"
                           },
                           "283": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 300
                               },
                               "ID": 901,
                               "ResearchTime": 100,
                               "internal_name": "Cavalier"
                           },
                           "330": {
                               "Cost": {
                                   "Food": 325,
                                   "Gold": 360
                               },
                               "ID": 901,
                               "ResearchTime": 105,
                               "internal_name": "Heavy Camel"
                           },
                           "358": {
                               "Cost": {
                                   "Food": 215,
                                   "Gold": 90
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Pikeman"
                           },
                           "359": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Halberdier"
                           },
                           "420": {
                               "Cost": {},
                               "ID": 901,
                               "ResearchTime": 0,
                               "internal_name": "Cannon Galleon"
                           },
                           "422": {
                               "Cost": {
                                   "Food": 300
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Capped Ram"
                           },
                           "441": {
                               "Cost": {
                                   "Food": 500,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Hussar"
                           },
                           "442": {
                               "Cost": {
                                   "Food": 400,
                                   "Wood": 315
                               },
                               "ID": 901,
                               "ResearchTime": 65,
                               "internal_name": "Galleon"
                           },
                           "473": {
                               "Cost": {
                                   "Food": 300,
                                   "Gold": 100
                               },
                               "ID": 901,
                               "ResearchTime": 75,
                               "internal_name": "Two-Handed Swordsman"
                           },
                           "474": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Heavy Cavalry Archer"
                           },
                           "492": {
                               "Cost": {
                                   "Food": 450,
                                   "Gold": 400
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Arbalest"
                           },
                           "527": {
                               "Cost": {
                                   "Food": 230,
                                   "Gold": 100
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "War Galley"
                           },
                           "528": {
                               "Cost": {
                                   "Gold": 300,
                                   "Wood": 200
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Heavy Demolition"
                           },
                           "529": {
                               "Cost": {
                                   "Food": 230,
                                   "Gold": 100
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "War Galley"
                           },
                           "530": {
                               "Cost": {
                                   "Food": 850,
                                   "Gold": 850
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Longbow"
                           },
                           "531": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Throwing Axemen"
                           },
                           "532": {
                               "Cost": {
                                   "Gold": 250,
                                   "Wood": 280
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Fast Fire Ship"
                           },
                           "533": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 475
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Unique Heroic Viking LBT"
                           },
                           "534": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Woad Raider"
                           },
                           "542": {
                               "Cost": {
                                   "Food": 1000,
                                   "Wood": 1100
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Heavy Scorpion"
                           },
                           "546": {
                               "Cost": {
                                   "Food": 150,
                                   "Gold": 50
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Light Cavalry"
                           },
                           "548": {
                               "Cost": {
                                   "Food": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 75,
                               "internal_name": "Siege Ram"
                           },
                           "550": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 75,
                               "internal_name": "Onager"
                           },
                           "553": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Cataphract"
                           },
                           "554": {
                               "Cost": {
                                   "Food": 950,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Teutonic Knight"
                           },
                           "555": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 550
                               },
                               "ID": 901,
                               "ResearchTime": 40,
                               "internal_name": "Elite Huskarl"
                           },
                           "556": {
                               "Cost": {
                                   "Food": 600,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Mameluke"
                           },
                           "557": {
                               "Cost": {
                                   "Food": 850,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 55,
                               "internal_name": "Elite Jannisary"
                           },
                           "558": {
                               "Cost": {
                                   "Food": 1600,
                                   "Gold": 1200
                               },
                               "ID": 901,
                               "ResearchTime": 75,
                               "internal_name": "Elite War Elephant"
                           },
                           "559": {
                               "Cost": {
                                   "Food": 950,
                                   "Gold": 950
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Chu Ko Nu"
                           },
                           "560": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 650
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Samurai"
                           },
                           "561": {
                               "Cost": {
                                   "Food": 1100,
                                   "Gold": 675
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Mangudai"
                           },
                           "567": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 350
                               },
                               "ID": 901,
                               "ResearchTime": 100,
                               "internal_name": "Champion"
                           },
                           "569": {
                               "Cost": {
                                   "Food": 1300,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 170,
                               "internal_name": "Paladin"
                           },
                           "588": {
                               "Cost": {
                                   "Food": 1450,
                                   "Gold": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 150,
                               "internal_name": "Siege Onager"
                           },
                           "691": {
                               "Cost": {
                                   "Gold": 500,
                                   "Wood": 525
                               },
                               "ID": 901,
                               "ResearchTime": 30,
                               "internal_name": "Elite Cannon Galley"
                           },
                           "694": {
                               "Cost": {
                                   "Food": 1075,
                                   "Gold": 475
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Berserk"
                           },
                           "726": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Jaguar Man"
                           },
                           "752": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Elite Eagle Warrior"
                           },
                           "753": {
                               "Cost": {
                                   "Food": 200,
                                   "Gold": 200
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Heavy Eagle Warrior"
                           },
                           "757": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Tarkan"
                           },
                           "761": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 550
                               },
                               "ID": 901,
                               "ResearchTime": 40,
                               "internal_name": "Elite Huskarl"
                           },
                           "765": {
                               "Cost": {
                                   "Food": 700,
                                   "Wood": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Plumed Archer"
                           },
                           "773": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Conquistador"
                           },
                           "829": {
                               "Cost": {
                                   "Gold": 800,
                                   "Wood": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 75,
                               "internal_name": "Elite War Wagon"
                           },
                           "832": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 65,
                               "internal_name": "Elite Turtle Ship"
                           },
                           "868": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Genoese Bow"
                           },
                           "871": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Magyar Huszar"
                           },
                           "875": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 80,
                               "internal_name": "Elite Elephant Archer"
                           },
                           "878": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Siege Tower"
                           },
                           "881": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Kamayuk"
                           },
                           "887": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Tarkan"
                           },
                           "1003": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Organ Gun"
                           },
                           "1006": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 475
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Caravel"
                           },
                           "1009": {
                               "Cost": {
                                   "Gold": 500,
                                   "Wood": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Camel Archer"
                           },
                           "1012": {
                               "Cost": {
                                   "Food": 500,
                                   "Wood": 450
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Genitour"
                           },
                           "1015": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Mali Unit"
                           },
                           "1018": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 450
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Ethiopia Unit"
                           },
                           "1122": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 70,
                               "internal_name": "Elite Ballista Elephant"
                           },
                           "1125": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 40,
                               "internal_name": "Elite Karambit Warrior"
                           },
                           "1128": {
                               "Cost": {
                                   "Food": 1100,
                                   "Gold": 675
                               },
                               "ID": 901,
                               "ResearchTime": 65,
                               "internal_name": "Elite Arambai"
                           },
                           "1131": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Rattan Archer"
                           },
                           "1132": {
                               "Cost": {},
                               "ID": 901,
                               "ResearchTime": 0,
                               "internal_name": "Battle Elephant (make avail)"
                           },
                           "1134": {
                               "Cost": {
                                   "Food": 1200,
                                   "Gold": 900
                               },
                               "ID": 901,
                               "ResearchTime": 100,
                               "internal_name": "Elite Battle Elephant"
                           },
                           "1155": {
                               "Cost": {
                                   "Gold": 450,
                                   "Wood": 300
                               },
                               "ID": 901,
                               "ResearchTime": 50,
                               "internal_name": "Imperial Skirmisher"
                           },
                           "1227": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 70,
                               "internal_name": "Elite Konnik"
                           },
                           "1230": {
                               "Cost": {
                                   "Food": 700,
                                   "Gold": 900
                               },
                               "ID": 901,
                               "ResearchTime": 40,
                               "internal_name": "Elite Keshik"
                           },
                           "1233": {
                               "Cost": {
                                   "Food": 1100,
                                   "Wood": 1000
                               },
                               "ID": 901,
                               "ResearchTime": 65,
                               "internal_name": "Elite Kipchak"
                           },
                           "1236": {
                               "Cost": {
                                   "Food": 750,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Leitis"
                           },
                           "1255": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 70,
                               "internal_name": "Elite Konnik"
                           },
                           "1372": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 550
                               },
                               "ID": 901,
                               "ResearchTime": 55,
                               "internal_name": "Elite Steppe Lancer"
                           },
                           "1657": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Coustillier"
                           },
                           "1659": {
                               "Cost": {
                                   "Food": 1100,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Serjeant"
                           },
                           "1661": {
                               "Cost": {
                                   "Food": 1100,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Serjeant"
                           },
                           "1703": {
                               "Cost": {
                                   "Food": 800,
                                   "Gold": 600
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Obuch"
                           },
                           "1706": {
                               "Cost": {
                                   "Gold": 600,
                                   "Wood": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Hussite Wagon"
                           },
                           "1707": {
                               "Cost": {
                                   "Food": 600,
                                   "Gold": 800
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Winged Hussar"
                           },
                           "1709": {
                               "Cost": {
                                   "Food": 950,
                                   "Gold": 750
                               },
                               "ID": 901,
                               "ResearchTime": 140,
                               "internal_name": "Houfnice"
                           },
                           "1737": {
                               "Cost": {
                                   "Food": 900,
                                   "Gold": 450
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Urumi Swordsman"
                           },
                           "1743": {
                               "Cost": {
                                   "Food": 1000,
                                   "Gold": 650
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Chakram Thrower"
                           },
                           "1746": {
                               "Cost": {
                                   "Food": 650
                               },
                               "ID": 901,
                               "ResearchTime": 60,
                               "internal_name": "Elite Armored Elephant"
                           },
                           "1749": {
                               "Cost": {
                                   "Food": 950,
                                   "Gold": 575
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Ghulam"
                           },
                           "1753": {
                               "Cost": {
                                   "Food": 850,
                                   "Gold": 500
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Shrivamsha Rider"
                           },
                           "1761": {
                               "Cost": {
                                   "Food": 800,
                                   "Wood": 800
                               },
                               "ID": 901,
                               "ResearchTime": 45,
                               "internal_name": "Elite Ratha"
                           }
                       },
                       "units": {
                           "4": {
                               "AccuracyPercent": 80,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.35,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 25
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 30,
                               "ID": 4,
                               "LanguageHelpId": 26083,
                               "LanguageNameId": 5083,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 35,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ARCHR"
                           },
                           "5": {
                               "AccuracyPercent": 75,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 17,
                               "AttackDelaySeconds": 0.35,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 45,
                                   "Gold": 50
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 5,
                               "LanguageHelpId": 26086,
                               "LanguageNameId": 5086,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.96,
                               "TrainTime": 34,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HCANR"
                           },
                           "6": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.5066666666666667,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 25,
                                   "Wood": 35
                               },
                               "FrameDelay": 19,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 6,
                               "LanguageHelpId": 26087,
                               "LanguageNameId": 5087,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 4,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.96,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HXBOW"
                           },
                           "7": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 2,
                               "AttackDelaySeconds": 0.5066666666666667,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 25,
                                   "Wood": 35
                               },
                               "FrameDelay": 19,
                               "GarrisonCapacity": 0,
                               "HP": 30,
                               "ID": 7,
                               "LanguageHelpId": 26088,
                               "LanguageNameId": 5088,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 3,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.96,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "XBOWM"
                           },
                           "8": {
                               "AccuracyPercent": 70,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 40,
                                   "Wood": 35
                               },
                               "FrameDelay": 10,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 8,
                               "LanguageHelpId": 26107,
                               "LanguageNameId": 5107,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "LNGBW"
                           },
                           "11": {
                               "AccuracyPercent": 95,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.49833333333333335,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 20
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 65,
                                   "Wood": 55
                               },
                               "FrameDelay": 23,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 11,
                               "LanguageHelpId": 26108,
                               "LanguageNameId": 5108,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2.1,
                               "Speed": 1.4,
                               "TrainTime": 26,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "MOSUN"
                           },
                           "13": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 34
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Wood": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 13,
                               "LanguageHelpId": 26090,
                               "LanguageNameId": 5090,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 0,
                               "Speed": 1.26,
                               "TrainTime": 40,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "FSHSP"
                           },
                           "17": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 17,
                               "LanguageHelpId": 26089,
                               "LanguageNameId": 5089,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 0,
                               "Speed": 1.32,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "COGXX"
                           },
                           "21": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 30,
                                   "Wood": 90
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 135,
                               "ID": 21,
                               "LanguageHelpId": 26091,
                               "LanguageNameId": 5091,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.43,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "GALLY"
                           },
                           "24": {
                               "AccuracyPercent": 85,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.35,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 25
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 24,
                               "LanguageHelpId": 26084,
                               "LanguageNameId": 5084,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 27,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CARCH"
                           },
                           "25": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 85,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 25,
                               "LanguageHelpId": 26112,
                               "LanguageNameId": 5112,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 7,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.8,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "TKNIT"
                           },
                           "36": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 40,
                               "AttackDelaySeconds": 0.21,
                               "Attacks": [
                                   {
                                       "Amount": 200,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 34
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 37
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 225,
                                   "Wood": 225
                               },
                               "FrameDelay": 7,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 36,
                               "LanguageHelpId": 26093,
                               "LanguageNameId": 5093,
                               "LineOfSight": 14,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 5,
                               "PierceArmor": 5,
                               "Range": 12,
                               "RechargeRate": 0,
                               "ReloadTime": 6.5,
                               "Speed": 0.7,
                               "TrainTime": 56,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "BCANN"
                           },
                           "38": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 38,
                               "LanguageHelpId": 26068,
                               "LanguageNameId": 5068,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.35,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KNGHT"
                           },
                           "39": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.9099999999999999,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 40
                               },
                               "FrameDelay": 35,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 39,
                               "LanguageHelpId": 26085,
                               "LanguageNameId": 5085,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 34,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CVRCH"
                           },
                           "40": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 110,
                               "ID": 40,
                               "LanguageHelpId": 26101,
                               "LanguageNameId": 5101,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.35,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CATAP"
                           },
                           "41": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 41,
                               "LanguageHelpId": 26104,
                               "LanguageNameId": 5104,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GBRSK"
                           },
                           "42": {
                               "AccuracyPercent": 15,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 150,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 200,
                               "AttackDelaySeconds": 0.8800000000000001,
                               "Attacks": [
                                   {
                                       "Amount": 250,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 200,
                                       "Class": 3
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 200,
                                   "Wood": 200
                               },
                               "FrameDelay": 24,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 42,
                               "LanguageHelpId": 26097,
                               "LanguageNameId": 5097,
                               "LineOfSight": 19,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 4,
                               "PierceArmor": 150,
                               "Range": 16,
                               "RechargeRate": 0,
                               "ReloadTime": 10,
                               "Speed": 0,
                               "TrainTime": 50,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "TREBU"
                           },
                           "46": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 17,
                               "AttackDelaySeconds": 0.4,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 55
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 46,
                               "LanguageHelpId": 26105,
                               "LanguageNameId": 5105,
                               "LineOfSight": 10,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 8,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.96,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "JANNI"
                           },
                           "73": {
                               "AccuracyPercent": 85,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.22166666666666665,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 35,
                                   "Wood": 40
                               },
                               "FrameDelay": 19,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 73,
                               "LanguageHelpId": 26102,
                               "LanguageNameId": 5102,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.96,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CHUKN"
                           },
                           "74": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 74,
                               "LanguageHelpId": 26079,
                               "LanguageNameId": 5079,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SPRMN"
                           },
                           "75": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 75,
                               "LanguageHelpId": 26080,
                               "LanguageNameId": 5080,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SWDMN"
                           },
                           "77": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 77,
                               "LanguageHelpId": 26081,
                               "LanguageNameId": 5081,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "THSWD"
                           },
                           "83": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 14
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 25,
                               "ID": 83,
                               "LanguageHelpId": 26121,
                               "LanguageNameId": 5606,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.8,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "VMBAS"
                           },
                           "93": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 35,
                                   "Wood": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 93,
                               "LanguageHelpId": 26078,
                               "LanguageNameId": 5078,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "PKEMN"
                           },
                           "125": {
                               "AccuracyPercent": 25,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 30,
                               "ID": 125,
                               "LanguageHelpId": 26099,
                               "LanguageNameId": 5099,
                               "LineOfSight": 11,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 9,
                               "RechargeRate": 0,
                               "ReloadTime": 1,
                               "Speed": 0.7,
                               "TrainTime": 51,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "MONKX"
                           },
                           "128": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 128,
                               "LanguageHelpId": 26100,
                               "LanguageNameId": 19052,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 0,
                               "Speed": 1,
                               "TrainTime": 51,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "TCART"
                           },
                           "185": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.795872,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 30,
                                   "Gold": 40
                               },
                               "FrameDelay": 14,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 185,
                               "LanguageHelpId": 26690,
                               "LanguageNameId": 5690,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SLINGR"
                           },
                           "207": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 18,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 1,
                               "HP": 140,
                               "ID": 207,
                               "LanguageHelpId": 26419,
                               "LanguageNameId": 5419,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.45,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SHCLRY"
                           },
                           "232": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 232,
                               "LanguageHelpId": 26113,
                               "LanguageNameId": 5113,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 10,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "WBRSK"
                           },
                           "239": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 15,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 170,
                                   "Gold": 85
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 450,
                               "ID": 239,
                               "LanguageHelpId": 26109,
                               "LanguageNameId": 5109,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.6,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "MPCAV"
                           },
                           "250": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 130,
                               "ID": 250,
                               "LanguageHelpId": 26106,
                               "LanguageNameId": 5106,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.54,
                               "TrainTime": 25,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "LNGBT"
                           },
                           "279": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.21,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 75,
                                   "Wood": 75
                               },
                               "FrameDelay": 42,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 279,
                               "LanguageHelpId": 26096,
                               "LanguageNameId": 5096,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 2,
                               "PierceArmor": 7,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3.6,
                               "Speed": 0.65,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SCBAL"
                           },
                           "280": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 40,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 35,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 37
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 135,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 280,
                               "LanguageHelpId": 26095,
                               "LanguageNameId": 5095,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 3,
                               "PierceArmor": 6,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 6,
                               "Speed": 0.6,
                               "TrainTime": 46,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "MANGO"
                           },
                           "281": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.9955555555555556,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 25
                               },
                               "FrameDelay": 28,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 281,
                               "LanguageHelpId": 26111,
                               "LanguageNameId": 5111,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 3,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 17,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "TAXEM"
                           },
                           "282": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.4,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 85
                               },
                               "FrameDelay": 24,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 282,
                               "LanguageHelpId": 26103,
                               "LanguageNameId": 5103,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 3,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 23,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "DERVI"
                           },
                           "283": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 283,
                               "LanguageHelpId": 26070,
                               "LanguageNameId": 5070,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.35,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "PALDN"
                           },
                           "291": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 19
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 291,
                               "LanguageHelpId": 26110,
                               "LanguageNameId": 5110,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1,
                               "TrainTime": 9,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SMURI"
                           },
                           "329": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 1,
                               "HP": 100,
                               "ID": 329,
                               "LanguageHelpId": 26416,
                               "LanguageNameId": 5416,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.45,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CVLRY"
                           },
                           "330": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 18,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 1,
                               "HP": 120,
                               "ID": 330,
                               "LanguageHelpId": 26417,
                               "LanguageNameId": 5417,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.45,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HCLRY"
                           },
                           "331": {
                               "AccuracyPercent": 92,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 200,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 250,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 200,
                                       "Class": 3
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 200,
                                   "Wood": 200
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 331,
                               "LanguageHelpId": 26381,
                               "LanguageNameId": 5097,
                               "LineOfSight": 19,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 4,
                               "PierceArmor": 8,
                               "Range": 16,
                               "RechargeRate": 0,
                               "ReloadTime": 10,
                               "Speed": 0.8,
                               "TrainTime": 50,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "PTREB"
                           },
                           "358": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 25,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 22,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 18,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 35,
                                   "Wood": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 358,
                               "LanguageHelpId": 26408,
                               "LanguageNameId": 5408,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ISPKM"
                           },
                           "359": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 28,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 32,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 26,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 35,
                                   "Wood": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 359,
                               "LanguageHelpId": 26409,
                               "LanguageNameId": 5409,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HLBDM"
                           },
                           "420": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 35,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 200,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 35,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 35
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 150,
                                   "Wood": 200
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 420,
                               "LanguageHelpId": 26287,
                               "LanguageNameId": 5287,
                               "LineOfSight": 15,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 3,
                               "PierceArmor": 6,
                               "Range": 13,
                               "RechargeRate": 0,
                               "ReloadTime": 10,
                               "Speed": 1.1,
                               "TrainTime": 46,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "CANGA"
                           },
                           "422": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": -3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 190,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 150,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 20
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 75,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 5,
                               "HP": 200,
                               "ID": 422,
                               "LanguageHelpId": 26289,
                               "LanguageNameId": 5289,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": -3,
                               "MinRange": 0,
                               "PierceArmor": 190,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 0.5,
                               "TrainTime": 36,
                               "Trait": 1,
                               "TraitPiece": 0,
                               "internal_name": "CBATR"
                           },
                           "440": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 25,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 100,
                                       "Class": 26
                                   },
                                   {
                                       "Amount": 500,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 25,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 60,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 900,
                                       "Class": 22
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 440,
                               "LanguageHelpId": 26660,
                               "LanguageNameId": 5660,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 0.8,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "PETARD"
                           },
                           "441": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 75,
                               "ID": 441,
                               "LanguageHelpId": 26661,
                               "LanguageNameId": 5661,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.5,
                               "TrainTime": 30,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "HUSSAR"
                           },
                           "442": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 30,
                                   "Wood": 90
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 165,
                               "ID": 442,
                               "LanguageHelpId": 26309,
                               "LanguageNameId": 5309,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.43,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "WARGA"
                           },
                           "448": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 448,
                               "LanguageHelpId": 26326,
                               "LanguageNameId": 5326,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 30,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "SCOUT"
                           },
                           "473": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 473,
                               "LanguageHelpId": 26411,
                               "LanguageNameId": 5411,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HTHSW"
                           },
                           "474": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.8969999999999999,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 40
                               },
                               "FrameDelay": 46,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 474,
                               "LanguageHelpId": 26412,
                               "LanguageNameId": 5412,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 27,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HCVAR"
                           },
                           "492": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.3422222222222222,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 13
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 25
                               },
                               "FrameDelay": 20,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 492,
                               "LanguageHelpId": 26418,
                               "LanguageNameId": 5418,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 27,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ACOAR"
                           },
                           "527": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 3,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 110,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 220,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 110,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 527,
                               "LanguageHelpId": 26424,
                               "LanguageNameId": 5424,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 1.6,
                               "TrainTime": 31,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "RMSHP"
                           },
                           "528": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 5,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 140,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 280,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 140,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 528,
                               "LanguageHelpId": 26425,
                               "LanguageNameId": 5425,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 5,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 1.6,
                               "TrainTime": 31,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "CRMSH"
                           },
                           "529": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 6,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 2,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 529,
                               "LanguageHelpId": 26426,
                               "LanguageNameId": 5426,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 2.49,
                               "RechargeRate": 0,
                               "ReloadTime": 0.25,
                               "Speed": 1.35,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "FRGAL"
                           },
                           "530": {
                               "AccuracyPercent": 80,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 40,
                                   "Wood": 35
                               },
                               "FrameDelay": 10,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 530,
                               "LanguageHelpId": 26456,
                               "LanguageNameId": 5456,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ULGBW"
                           },
                           "531": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.8177777777777778,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 25
                               },
                               "FrameDelay": 23,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 531,
                               "LanguageHelpId": 26461,
                               "LanguageNameId": 5461,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 17,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UTAXE"
                           },
                           "532": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 140,
                               "ID": 532,
                               "LanguageHelpId": 26429,
                               "LanguageNameId": 5429,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 2.49,
                               "RechargeRate": 0,
                               "ReloadTime": 0.25,
                               "Speed": 1.43,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "HFGAL"
                           },
                           "533": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 160,
                               "ID": 533,
                               "LanguageHelpId": 26457,
                               "LanguageNameId": 5457,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.54,
                               "TrainTime": 25,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "ULNGB"
                           },
                           "534": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 13,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 13,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 534,
                               "LanguageHelpId": 26463,
                               "LanguageNameId": 5463,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 10,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UWBRS"
                           },
                           "539": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 30,
                                   "Wood": 90
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 539,
                               "LanguageHelpId": 26436,
                               "LanguageNameId": 5436,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.43,
                               "TrainTime": 60,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "SGALY"
                           },
                           "542": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 16,
                               "AttackDelaySeconds": 0.20800000000000002,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 75,
                                   "Wood": 75
                               },
                               "FrameDelay": 26,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 542,
                               "LanguageHelpId": 26439,
                               "LanguageNameId": 5439,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 2,
                               "PierceArmor": 8,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3.6,
                               "Speed": 0.65,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HWBAL"
                           },
                           "545": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Wood": 125
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 5,
                               "HP": 100,
                               "ID": 545,
                               "LanguageHelpId": 26443,
                               "LanguageNameId": 5443,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 4,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 0,
                               "Speed": 1.45,
                               "TrainTime": 46,
                               "Trait": 3,
                               "TraitPiece": 0,
                               "internal_name": "XPORT"
                           },
                           "546": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 546,
                               "LanguageHelpId": 26444,
                               "LanguageNameId": 5444,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.5,
                               "TrainTime": 30,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "LTCAV"
                           },
                           "548": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": -3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 195,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 200,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 65,
                                       "Class": 20
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 75,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 6,
                               "HP": 270,
                               "ID": 548,
                               "LanguageHelpId": 26446,
                               "LanguageNameId": 5446,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": -3,
                               "MinRange": 0,
                               "PierceArmor": 195,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 0.6,
                               "TrainTime": 36,
                               "Trait": 1,
                               "TraitPiece": 0,
                               "internal_name": "SGRAM"
                           },
                           "550": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 50,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 45,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 37
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 135,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 550,
                               "LanguageHelpId": 26448,
                               "LanguageNameId": 5448,
                               "LineOfSight": 10,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 3,
                               "PierceArmor": 7,
                               "Range": 8,
                               "RechargeRate": 0,
                               "ReloadTime": 6,
                               "Speed": 0.6,
                               "TrainTime": 46,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ONAGR"
                           },
                           "553": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 553,
                               "LanguageHelpId": 26451,
                               "LanguageNameId": 5451,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.7,
                               "Speed": 1.35,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UCATA"
                           },
                           "554": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 17,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 85,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 554,
                               "LanguageHelpId": 26462,
                               "LanguageNameId": 5462,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 10,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.8,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UTKNI"
                           },
                           "555": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 555,
                               "LanguageHelpId": 26454,
                               "LanguageNameId": 5454,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UGBRS"
                           },
                           "556": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 35
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.2,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 35
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 85
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 556,
                               "LanguageHelpId": 26453,
                               "LanguageNameId": 5453,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 3,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 23,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UDERV"
                           },
                           "557": {
                               "AccuracyPercent": 65,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 22,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 22,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 55
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 557,
                               "LanguageHelpId": 26455,
                               "LanguageNameId": 5455,
                               "LineOfSight": 10,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 8,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.96,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UJANI"
                           },
                           "558": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 20,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 170,
                                   "Gold": 85
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 600,
                               "ID": 558,
                               "LanguageHelpId": 26459,
                               "LanguageNameId": 5459,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.6,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UMPCAV"
                           },
                           "559": {
                               "AccuracyPercent": 85,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.22166666666666665,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 35,
                                   "Wood": 40
                               },
                               "FrameDelay": 19,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 559,
                               "LanguageHelpId": 26452,
                               "LanguageNameId": 5452,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.96,
                               "TrainTime": 13,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UCHUK"
                           },
                           "560": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 19
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 560,
                               "LanguageHelpId": 26460,
                               "LanguageNameId": 5460,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1,
                               "TrainTime": 9,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "USMUR"
                           },
                           "561": {
                               "AccuracyPercent": 95,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.49833333333333335,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 20
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 65,
                                   "Wood": 55
                               },
                               "FrameDelay": 23,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 561,
                               "LanguageHelpId": 26458,
                               "LanguageNameId": 5458,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2.1,
                               "Speed": 1.4,
                               "TrainTime": 26,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UMOSU"
                           },
                           "567": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 13,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 13,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 567,
                               "LanguageHelpId": 26469,
                               "LanguageNameId": 5469,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HEROI"
                           },
                           "569": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 160,
                               "ID": 569,
                               "LanguageHelpId": 26471,
                               "LanguageNameId": 5471,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.35,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HEROC"
                           },
                           "588": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 75,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 60,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 75,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 75,
                                       "Class": 37
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 135,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 588,
                               "LanguageHelpId": 26493,
                               "LanguageNameId": 5493,
                               "LineOfSight": 10,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 3,
                               "PierceArmor": 8,
                               "Range": 8,
                               "RechargeRate": 0,
                               "ReloadTime": 6,
                               "Speed": 0.6,
                               "TrainTime": 46,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SNAGR"
                           },
                           "691": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 45,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 275,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 45,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 35
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 150,
                                   "Wood": 200
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 691,
                               "LanguageHelpId": 26573,
                               "LanguageNameId": 5573,
                               "LineOfSight": 17,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 3,
                               "PierceArmor": 8,
                               "Range": 15,
                               "RechargeRate": 0,
                               "ReloadTime": 10,
                               "Speed": 1.1,
                               "TrainTime": 46,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "CNGAU"
                           },
                           "692": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 54,
                               "ID": 692,
                               "LanguageHelpId": 26574,
                               "LanguageNameId": 5574,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "VBRSK"
                           },
                           "694": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 62,
                               "ID": 694,
                               "LanguageHelpId": 26576,
                               "LanguageNameId": 5576,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UVBRK"
                           },
                           "725": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 725,
                               "LanguageHelpId": 26667,
                               "LanguageNameId": 5667,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "JAGUAR"
                           },
                           "726": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 75,
                               "ID": 726,
                               "LanguageHelpId": 26669,
                               "LanguageNameId": 5669,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "JAGUARX"
                           },
                           "751": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 20,
                                   "Gold": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 751,
                               "LanguageHelpId": 26672,
                               "LanguageNameId": 5672,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.1,
                               "TrainTime": 60,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "EAGLE"
                           },
                           "752": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 20,
                                   "Gold": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 752,
                               "LanguageHelpId": 26673,
                               "LanguageNameId": 5673,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 20,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "EAGLEX"
                           },
                           "753": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 20,
                                   "Gold": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 753,
                               "LanguageHelpId": 26671,
                               "LanguageNameId": 5671,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.15,
                               "TrainTime": 35,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "EAGLEH"
                           },
                           "755": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 26
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 755,
                               "LanguageHelpId": 26675,
                               "LanguageNameId": 5675,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.1,
                               "Speed": 1.35,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "TARKAN"
                           },
                           "757": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 26
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 22
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 757,
                               "LanguageHelpId": 26677,
                               "LanguageNameId": 5677,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.1,
                               "Speed": 1.35,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UTARK"
                           },
                           "763": {
                               "AccuracyPercent": 80,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 55,
                                   "Wood": 55
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 763,
                               "LanguageHelpId": 26683,
                               "LanguageNameId": 5683,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.2,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "PLUME"
                           },
                           "765": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 32
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 55,
                                   "Wood": 55
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 765,
                               "LanguageHelpId": 26685,
                               "LanguageNameId": 5685,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.2,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UPLUM"
                           },
                           "771": {
                               "AccuracyPercent": 65,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 16,
                               "AttackDelaySeconds": 0.40444444444444444,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 13,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 771,
                               "LanguageHelpId": 26687,
                               "LanguageNameId": 5687,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 2.9,
                               "Speed": 1.3,
                               "TrainTime": 24,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CONQI"
                           },
                           "773": {
                               "AccuracyPercent": 70,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 18,
                               "AttackDelaySeconds": 0.40444444444444444,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 18,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 13,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 773,
                               "LanguageHelpId": 26689,
                               "LanguageNameId": 5689,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 2.9,
                               "Speed": 1.3,
                               "TrainTime": 24,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UCONQ"
                           },
                           "775": {
                               "AccuracyPercent": 25,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 100
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 30,
                               "ID": 775,
                               "LanguageHelpId": 26691,
                               "LanguageNameId": 5691,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 1,
                               "Speed": 1.1,
                               "TrainTime": 51,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "MONKY"
                           },
                           "827": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": -1,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.9955555555555555,
                               "Attacks": [
                                   {
                                       "Amount": 5,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 125
                               },
                               "FrameDelay": 32,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 827,
                               "LanguageHelpId": 26727,
                               "LanguageNameId": 5727,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2.5,
                               "Speed": 1.2,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "WAGON"
                           },
                           "829": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": -1,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.9955555555555555,
                               "Attacks": [
                                   {
                                       "Amount": 5,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 125
                               },
                               "FrameDelay": 32,
                               "GarrisonCapacity": 0,
                               "HP": 200,
                               "ID": 829,
                               "LanguageHelpId": 26729,
                               "LanguageNameId": 5729,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2.5,
                               "Speed": 1.2,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UWAGO"
                           },
                           "831": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 8,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 50,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 50,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 180,
                                   "Wood": 190
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 200,
                               "ID": 831,
                               "LanguageHelpId": 26731,
                               "LanguageNameId": 5731,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 6,
                               "MinRange": 0,
                               "PierceArmor": 5,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 6,
                               "Speed": 0.9,
                               "TrainTime": 50,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "TURTL"
                           },
                           "832": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 11,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 50,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 50,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 180,
                                   "Wood": 190
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 300,
                               "ID": 832,
                               "LanguageHelpId": 26732,
                               "LanguageNameId": 5732,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 8,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 6,
                               "Speed": 1.035,
                               "TrainTime": 50,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "UTURT"
                           },
                           "866": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 40,
                                   "Wood": 45
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 866,
                               "LanguageHelpId": 26723,
                               "LanguageNameId": 5723,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GENOE"
                           },
                           "868": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 40,
                                   "Wood": 45
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 868,
                               "LanguageHelpId": 26725,
                               "LanguageNameId": 5725,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.96,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GENOE_E"
                           },
                           "869": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 10
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 869,
                               "LanguageHelpId": 26728,
                               "LanguageNameId": 5728,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.5,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UMAGYX"
                           },
                           "871": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 10
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 85,
                               "ID": 871,
                               "LanguageHelpId": 26730,
                               "LanguageNameId": 5730,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.5,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UMAGYX"
                           },
                           "873": {
                               "AccuracyPercent": 70,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -4,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.394,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 70
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 230,
                               "ID": 873,
                               "LanguageHelpId": 26682,
                               "LanguageNameId": 5682,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 34,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ELEAR"
                           },
                           "875": {
                               "AccuracyPercent": 85,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -4,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.394,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80,
                                   "Gold": 70
                               },
                               "FrameDelay": 24,
                               "GarrisonCapacity": 0,
                               "HP": 280,
                               "ID": 875,
                               "LanguageHelpId": 26684,
                               "LanguageNameId": 5684,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 34,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "UELEA"
                           },
                           "876": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 876,
                               "LanguageHelpId": 26447,
                               "LanguageNameId": 5447,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 4,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.3,
                               "TrainTime": 15,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "BOYAR"
                           },
                           "878": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 130,
                               "ID": 878,
                               "LanguageHelpId": 26449,
                               "LanguageNameId": 5449,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 8,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.3,
                               "TrainTime": 15,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EBOYA"
                           },
                           "879": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 5
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 879,
                               "LanguageHelpId": 26686,
                               "LanguageNameId": 5686,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 1,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 10,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KAMAY"
                           },
                           "881": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 35
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 881,
                               "LanguageHelpId": 26688,
                               "LanguageNameId": 5688,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 1,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1,
                               "TrainTime": 10,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKAMA"
                           },
                           "882": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 10,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 32
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 35
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 882,
                               "LanguageHelpId": 26114,
                               "LanguageNameId": 5114,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.2,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CONDO"
                           },
                           "1001": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 16,
                               "AttackDelaySeconds": 0.6,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 70,
                                   "Wood": 80
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 1001,
                               "LanguageHelpId": 26129,
                               "LanguageNameId": 5129,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 1,
                               "PierceArmor": 4,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.85,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ORGAN"
                           },
                           "1003": {
                               "AccuracyPercent": 50,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 20,
                               "AttackDelaySeconds": 0.6,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 70,
                                   "Wood": 80
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 1003,
                               "LanguageHelpId": 26130,
                               "LanguageNameId": 5130,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 1,
                               "PierceArmor": 6,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.85,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EORGAN"
                           },
                           "1004": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 43,
                                   "Wood": 90
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 130,
                               "ID": 1004,
                               "LanguageHelpId": 26132,
                               "LanguageNameId": 5132,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.43,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "CARAV"
                           },
                           "1006": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 43,
                                   "Wood": 90
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 150,
                               "ID": 1006,
                               "LanguageHelpId": 26133,
                               "LanguageNameId": 5133,
                               "LineOfSight": 9,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 8,
                               "Range": 7,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.43,
                               "TrainTime": 36,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "CARAV"
                           },
                           "1007": {
                               "AccuracyPercent": 95,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.625,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 50
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1007,
                               "LanguageHelpId": 26134,
                               "LanguageNameId": 5134,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CAMAR"
                           },
                           "1009": {
                               "AccuracyPercent": 95,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.625,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 50
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 1009,
                               "LanguageHelpId": 26136,
                               "LanguageNameId": 5136,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.4,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ECAMAR"
                           },
                           "1010": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 40,
                                   "Wood": 35
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 1010,
                               "LanguageHelpId": 26137,
                               "LanguageNameId": 5137,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 4,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.35,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GENITO"
                           },
                           "1012": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.5,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 40,
                                   "Wood": 35
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1012,
                               "LanguageHelpId": 26139,
                               "LanguageNameId": 5139,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 4,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 1.35,
                               "TrainTime": 23,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EGENITO"
                           },
                           "1013": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 1.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 40
                               },
                               "FrameDelay": 30,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 1013,
                               "LanguageHelpId": 26140,
                               "LanguageNameId": 5140,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.25,
                               "TrainTime": 17,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GBETO"
                           },
                           "1015": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 13,
                               "AttackDelaySeconds": 1.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 13,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 40
                               },
                               "FrameDelay": 30,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1015,
                               "LanguageHelpId": 26141,
                               "LanguageNameId": 5141,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.25,
                               "TrainTime": 17,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EGBETO"
                           },
                           "1016": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 16,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1016,
                               "LanguageHelpId": 26143,
                               "LanguageNameId": 5143,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 8,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SHOTEL"
                           },
                           "1018": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 18,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 18,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 50,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 1018,
                               "LanguageHelpId": 26145,
                               "LanguageNameId": 5145,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 8,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ESHOTEL"
                           },
                           "1103": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": 6,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 1,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 1103,
                               "LanguageHelpId": 26160,
                               "LanguageNameId": 5160,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 2.49,
                               "RechargeRate": 0,
                               "ReloadTime": 0.25,
                               "Speed": 1.3,
                               "TrainTime": 65,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "SFRGAL"
                           },
                           "1104": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 90,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 180,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 90,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 50,
                                   "Wood": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1104,
                               "LanguageHelpId": 26162,
                               "LanguageNameId": 5162,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 1.5,
                               "TrainTime": 45,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "SDGAL"
                           },
                           "1105": {
                               "AccuracyPercent": 0,
                               "Armours": [
                                   {
                                       "Amount": -2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 100,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 0,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 160,
                                   "Wood": 200
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 10,
                               "HP": 220,
                               "ID": 1105,
                               "LanguageHelpId": 26445,
                               "LanguageNameId": 5445,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": -2,
                               "MinRange": 0,
                               "PierceArmor": 100,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 0,
                               "Speed": 0.8,
                               "TrainTime": 36,
                               "Trait": 1,
                               "TraitPiece": 0,
                               "internal_name": "SIEGTWR"
                           },
                           "1120": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.394,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 100,
                                       "Class": 18
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 100,
                                   "Gold": 80
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 250,
                               "ID": 1120,
                               "LanguageHelpId": 26146,
                               "LanguageNameId": 5146,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2.5,
                               "Speed": 0.8,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ELEBALI"
                           },
                           "1122": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.394,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 100,
                                       "Class": 18
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 100,
                                   "Gold": 80
                               },
                               "FrameDelay": 12,
                               "GarrisonCapacity": 0,
                               "HP": 290,
                               "ID": 1122,
                               "LanguageHelpId": 26147,
                               "LanguageNameId": 5147,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2.5,
                               "Speed": 0.8,
                               "TrainTime": 25,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EELEBALI"
                           },
                           "1123": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 25,
                                   "Gold": 15
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 30,
                               "ID": 1123,
                               "LanguageHelpId": 26148,
                               "LanguageNameId": 5148,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 6,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KARAM"
                           },
                           "1125": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 25,
                                   "Gold": 15
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 1125,
                               "LanguageHelpId": 26150,
                               "LanguageNameId": 5150,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 6,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKARAM"
                           },
                           "1126": {
                               "AccuracyPercent": 20,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.6,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 75
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 1126,
                               "LanguageHelpId": 26151,
                               "LanguageNameId": 5151,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ARAMBAI"
                           },
                           "1128": {
                               "AccuracyPercent": 30,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 15,
                               "AttackDelaySeconds": 0.6,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 15,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 75
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 1128,
                               "LanguageHelpId": 26152,
                               "LanguageNameId": 5152,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EARAMBAI"
                           },
                           "1129": {
                               "AccuracyPercent": 80,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.6900000000000001,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 50
                               },
                               "FrameDelay": 23,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 1129,
                               "LanguageHelpId": 26165,
                               "LanguageNameId": 5165,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.1,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "RATAN"
                           },
                           "1131": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 7,
                               "AttackDelaySeconds": 0.6900000000000001,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 45,
                                   "Wood": 50
                               },
                               "FrameDelay": 23,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1131,
                               "LanguageHelpId": 26166,
                               "LanguageNameId": 5166,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.1,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ERATAN"
                           },
                           "1132": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 4,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 110,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 250,
                               "ID": 1132,
                               "LanguageHelpId": 26167,
                               "LanguageNameId": 5167,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.85,
                               "TrainTime": 24,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "BATELE"
                           },
                           "1134": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 7,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 110,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 300,
                               "ID": 1134,
                               "LanguageHelpId": 26168,
                               "LanguageNameId": 5168,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.85,
                               "TrainTime": 24,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EBATELE"
                           },
                           "1155": {
                               "AccuracyPercent": 95,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.5066666666666667,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 25,
                                   "Wood": 35
                               },
                               "FrameDelay": 19,
                               "GarrisonCapacity": 0,
                               "HP": 35,
                               "ID": 1155,
                               "LanguageHelpId": 26190,
                               "LanguageNameId": 5190,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 1,
                               "PierceArmor": 5,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.96,
                               "TrainTime": 22,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "IHXBOW"
                           },
                           "1225": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 1225,
                               "LanguageHelpId": 26288,
                               "LanguageNameId": 5288,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 1.35,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KONNIK"
                           },
                           "1227": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 1227,
                               "LanguageHelpId": 26290,
                               "LanguageNameId": 5290,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 1.35,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKONNIK"
                           },
                           "1228": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 110,
                               "ID": 1228,
                               "LanguageHelpId": 26313,
                               "LanguageNameId": 5313,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.4,
                               "TrainTime": 16,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KESHIK"
                           },
                           "1230": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 140,
                               "ID": 1230,
                               "LanguageHelpId": 26314,
                               "LanguageNameId": 5314,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.4,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKESHIK"
                           },
                           "1231": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.49,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 35,
                                   "Wood": 60
                               },
                               "FrameDelay": 21,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 1231,
                               "LanguageHelpId": 26315,
                               "LanguageNameId": 5315,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2.2,
                               "Speed": 1.4,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KIPCHAK"
                           },
                           "1233": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.49,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 27
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 35,
                                   "Wood": 60
                               },
                               "FrameDelay": 21,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1233,
                               "LanguageHelpId": 26327,
                               "LanguageNameId": 5327,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2.2,
                               "Speed": 1.4,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKIPCHAK"
                           },
                           "1234": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 13,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 13,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 1234,
                               "LanguageHelpId": 26328,
                               "LanguageNameId": 5328,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.4,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "LEITIS"
                           },
                           "1236": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 16,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 16,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 50
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 130,
                               "ID": 1236,
                               "LanguageHelpId": 26329,
                               "LanguageNameId": 5329,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.4,
                               "TrainTime": 18,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ELEITIS"
                           },
                           "1252": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 0
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1252,
                               "LanguageHelpId": 42057,
                               "LanguageNameId": 21057,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 0.9,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KONNIK_INF"
                           },
                           "1253": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 13,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 13,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 0,
                                   "Gold": 0
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 1253,
                               "LanguageHelpId": 42058,
                               "LanguageNameId": 21058,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 0.9,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKONNIK_INF"
                           },
                           "1254": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 1254,
                               "LanguageHelpId": 26288,
                               "LanguageNameId": 5288,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 1.35,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "KONNIK"
                           },
                           "1255": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 14,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 14,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 70
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 120,
                               "ID": 1255,
                               "LanguageHelpId": 26290,
                               "LanguageNameId": 5290,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2.4,
                               "Speed": 1.35,
                               "TrainTime": 19,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EKONNIK"
                           },
                           "1258": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": -3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 180,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 2,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 125,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 40,
                                       "Class": 20
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 75,
                                   "Wood": 160
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 4,
                               "HP": 175,
                               "ID": 1258,
                               "LanguageHelpId": 26094,
                               "LanguageNameId": 5094,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": -3,
                               "MinRange": 0,
                               "PierceArmor": 180,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 0.5,
                               "TrainTime": 36,
                               "Trait": 1,
                               "TraitPiece": 0,
                               "internal_name": "BTRAM"
                           },
                           "1263": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 20,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 200,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 130,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 25,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 75,
                                   "Gold": 30
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1263,
                               "LanguageHelpId": 26375,
                               "LanguageNameId": 5375,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 5,
                               "Speed": 1.3,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "FCAMEL"
                           },
                           "1370": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 60,
                               "ID": 1370,
                               "LanguageHelpId": 26009,
                               "LanguageNameId": 5009,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 1,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.45,
                               "TrainTime": 24,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SLANCER"
                           },
                           "1372": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 40
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 1372,
                               "LanguageHelpId": 26010,
                               "LanguageNameId": 5010,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 1,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.45,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ESLANCER"
                           },
                           "1570": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 75
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 100,
                               "ID": 1570,
                               "LanguageHelpId": 26040,
                               "LanguageNameId": 5040,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.8,
                               "Speed": 1.35,
                               "TrainTime": 30,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "AZTRAIDER"
                           },
                           "1655": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 1,
                               "ChargeType": 1,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 55
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 115,
                               "ID": 1655,
                               "LanguageHelpId": 26534,
                               "LanguageNameId": 5534,
                               "LineOfSight": 5,
                               "MaxCharge": 20,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeDuration": 40.0,
                               "RechargeRate": 0.5,
                               "ReloadTime": 1.9,
                               "Speed": 1.35,
                               "TrainTime": 15,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "COUSTILLIER"
                           },
                           "1657": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 1,
                               "ChargeType": 1,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 55
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 145,
                               "ID": 1657,
                               "LanguageHelpId": 26536,
                               "LanguageNameId": 5536,
                               "LineOfSight": 5,
                               "MaxCharge": 25,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeDuration": 40.0,
                               "RechargeRate": 0.625,
                               "ReloadTime": 1.9,
                               "Speed": 1.35,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ECOUSTILLIER"
                           },
                           "1658": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 35
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1658,
                               "LanguageHelpId": 26538,
                               "LanguageNameId": 5538,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 12,
                               "Trait": 4,
                               "TraitPiece": 1665,
                               "internal_name": "SERJEANT"
                           },
                           "1659": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 35
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 85,
                               "ID": 1659,
                               "LanguageHelpId": 26540,
                               "LanguageNameId": 5540,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 4,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 12,
                               "Trait": 4,
                               "TraitPiece": 1665,
                               "internal_name": "ESERJEANT"
                           },
                           "1660": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 35
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 45,
                               "ID": 1660,
                               "LanguageHelpId": 26538,
                               "LanguageNameId": 5538,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 16,
                               "Trait": 4,
                               "TraitPiece": 1665,
                               "internal_name": "DSERJEANT"
                           },
                           "1661": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 35
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 85,
                               "ID": 1661,
                               "LanguageHelpId": 26540,
                               "LanguageNameId": 5540,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 4,
                               "MinRange": 0,
                               "PierceArmor": 4,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 12,
                               "Trait": 4,
                               "TraitPiece": 1665,
                               "internal_name": "EDSERJEANT"
                           },
                           "1699": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 60,
                                   "Gold": 25
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 75,
                               "ID": 1699,
                               "LanguageHelpId": 26542,
                               "LanguageNameId": 5542,
                               "LineOfSight": 5,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 14,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "FLEMISHPIKEMAN2"
                           },
                           "1701": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 1701,
                               "LanguageHelpId": 26558,
                               "LanguageNameId": 5558,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "OBUCH"
                           },
                           "1703": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 95,
                               "ID": 1703,
                               "LanguageHelpId": 26559,
                               "LanguageNameId": 5559,
                               "LineOfSight": 3,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 0.9,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EOBUCH"
                           },
                           "1704": {
                               "AccuracyPercent": 85,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 37
                                   }
                               ],
                               "Attack": 17,
                               "AttackDelaySeconds": 0.9333333333333333,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 17,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 70,
                                   "Wood": 110
                               },
                               "FrameDelay": 30,
                               "GarrisonCapacity": 0,
                               "HP": 200,
                               "ID": 1704,
                               "LanguageHelpId": 26561,
                               "LanguageNameId": 5561,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 7,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.8,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HUSSITEWAGON"
                           },
                           "1706": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 37
                                   }
                               ],
                               "Attack": 20,
                               "AttackDelaySeconds": 0.9333333333333333,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 17
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 70,
                                   "Wood": 110
                               },
                               "FrameDelay": 30,
                               "GarrisonCapacity": 0,
                               "HP": 250,
                               "ID": 1706,
                               "LanguageHelpId": 26563,
                               "LanguageNameId": 5563,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 0.8,
                               "TrainTime": 21,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EHUSSITEWAGON"
                           },
                           "1707": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 14,
                                       "Class": 25
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 23
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 80
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 80,
                               "ID": 1707,
                               "LanguageHelpId": 26577,
                               "LanguageNameId": 5577,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 2,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 1.9,
                               "Speed": 1.5,
                               "TrainTime": 30,
                               "Trait": 16,
                               "TraitPiece": 0,
                               "internal_name": "WINGEDHUSSAR"
                           },
                           "1709": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 23
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 50,
                               "AttackDelaySeconds": 0.21,
                               "Attacks": [
                                   {
                                       "Amount": 250,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 20,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 13
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 34
                                   },
                                   {
                                       "Amount": 50,
                                       "Class": 37
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 225,
                                   "Wood": 225
                               },
                               "FrameDelay": 7,
                               "GarrisonCapacity": 0,
                               "HP": 90,
                               "ID": 1709,
                               "LanguageHelpId": 26579,
                               "LanguageNameId": 5579,
                               "LineOfSight": 14,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 5,
                               "PierceArmor": 6,
                               "Range": 12,
                               "RechargeRate": 0,
                               "ReloadTime": 6.5,
                               "Speed": 0.7,
                               "TrainTime": 56,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "HOUFNICE"
                           },
                           "1735": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 1,
                               "ChargeType": 3,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1735,
                               "LanguageHelpId": 26403,
                               "LanguageNameId": 5403,
                               "LineOfSight": 3,
                               "MaxCharge": 12,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeDuration": 24.0,
                               "RechargeRate": 0.5,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 9,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "URUMI"
                           },
                           "1737": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 1,
                               "ChargeType": 3,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 1737,
                               "LanguageHelpId": 26413,
                               "LanguageNameId": 5413,
                               "LineOfSight": 3,
                               "MaxCharge": 15,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeDuration": 20.0,
                               "RechargeRate": 0.75,
                               "ReloadTime": 2,
                               "Speed": 1.05,
                               "TrainTime": 9,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EURUMI"
                           },
                           "1738": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 105,
                               "ID": 1738,
                               "LanguageHelpId": 42096,
                               "LanguageNameId": 21096,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 8,
                               "TraitPiece": 1759,
                               "internal_name": "RATHA"
                           },
                           "1740": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 12,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 12,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 115,
                               "ID": 1740,
                               "LanguageHelpId": 42097,
                               "LanguageNameId": 21097,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 8,
                               "TraitPiece": 1761,
                               "internal_name": "ERATHA"
                           },
                           "1741": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 3,
                               "AttackDelaySeconds": 0.8,
                               "Attacks": [
                                   {
                                       "Amount": 1,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 30
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 40,
                               "ID": 1741,
                               "LanguageHelpId": 26421,
                               "LanguageNameId": 5421,
                               "LineOfSight": 7,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 5,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.15,
                               "TrainTime": 15,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CHAKRAM"
                           },
                           "1743": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.8,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 1
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 65,
                                   "Gold": 30
                               },
                               "FrameDelay": 15,
                               "GarrisonCapacity": 0,
                               "HP": 50,
                               "ID": 1743,
                               "LanguageHelpId": 26427,
                               "LanguageNameId": 5427,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 1,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.15,
                               "TrainTime": 15,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ECHAKRAM"
                           },
                           "1744": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 17,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 7,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 140,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 75,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 25,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 130,
                                   "Gold": 95
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 200,
                               "ID": 1744,
                               "LanguageHelpId": 26428,
                               "LanguageNameId": 5428,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": -2,
                               "MinRange": 0,
                               "PierceArmor": 140,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.6,
                               "TrainTime": 36,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ARELE"
                           },
                           "1746": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 18,
                                       "Class": 5
                                   },
                                   {
                                       "Amount": -2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 8,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 150,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 4,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 105,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 35,
                                       "Class": 20
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 130,
                                   "Gold": 95
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 250,
                               "ID": 1746,
                               "LanguageHelpId": 26430,
                               "LanguageNameId": 5430,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": -2,
                               "MinRange": 0,
                               "PierceArmor": 150,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 3,
                               "Speed": 0.6,
                               "TrainTime": 36,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EARELE"
                           },
                           "1747": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 3,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 5,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 30,
                                   "Gold": 45
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1747,
                               "LanguageHelpId": 26431,
                               "LanguageNameId": 5431,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 3,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.15,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "GHULAM"
                           },
                           "1749": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 1
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 10,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 10,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 6,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 29
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 30,
                                   "Gold": 45
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 65,
                               "ID": 1749,
                               "LanguageHelpId": 26432,
                               "LanguageNameId": 5432,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 6,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 12,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "EGHULAM"
                           },
                           "1750": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 8,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 2
                                   },
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 10,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 9,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 9,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 4,
                                       "Class": 17
                                   },
                                   {
                                       "Amount": 9,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 180
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 250,
                               "ID": 1750,
                               "LanguageHelpId": 26435,
                               "LanguageNameId": 5435,
                               "LineOfSight": 8,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 10,
                               "Range": 6,
                               "RechargeRate": 0,
                               "ReloadTime": 3.45,
                               "Speed": 1.3,
                               "TrainTime": 40,
                               "Trait": 2,
                               "TraitPiece": 0,
                               "internal_name": "THIRISADAI"
                           },
                           "1751": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 8,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 8,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 4,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 55,
                               "ID": 1751,
                               "LanguageHelpId": 26437,
                               "LanguageNameId": 5437,
                               "LineOfSight": 5,
                               "MaxCharge": 5,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeDuration": 20.0,
                               "RechargeRate": 0.25,
                               "ReloadTime": 1.75,
                               "Speed": 1.6,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "SHRIVAMSHA"
                           },
                           "1753": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 11,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 11,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 4,
                               "Cost": {
                                   "Food": 70,
                                   "Gold": 20
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 0,
                               "HP": 70,
                               "ID": 1753,
                               "LanguageHelpId": 26438,
                               "LanguageNameId": 5438,
                               "LineOfSight": 6,
                               "MaxCharge": 7,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 0,
                               "RechargeDuration": 20.0,
                               "RechargeRate": 0.35,
                               "ReloadTime": 1.75,
                               "Speed": 1.6,
                               "TrainTime": 20,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "ESHRIVAMSHA"
                           },
                           "1755": {
                               "AccuracyPercent": 100,
                               "Armours": [
                                   {
                                       "Amount": 0,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 2,
                               "AttackDelaySeconds": 0.0,
                               "Attacks": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 16
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 30
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 34
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Food": 55,
                                   "Gold": 60
                               },
                               "FrameDelay": 0,
                               "GarrisonCapacity": 1,
                               "HP": 70,
                               "ID": 1755,
                               "LanguageHelpId": 26441,
                               "LanguageNameId": 5441,
                               "LineOfSight": 4,
                               "MaxCharge": 0,
                               "MeleeArmor": 0,
                               "MinRange": 0,
                               "PierceArmor": 0,
                               "Range": 0,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.2,
                               "TrainTime": 48,
                               "Trait": 0,
                               "TraitPiece": 0,
                               "internal_name": "CAMELSC"
                           },
                           "1759": {
                               "AccuracyPercent": 80,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 5,
                               "AttackDelaySeconds": 0.6206666666666667,
                               "Attacks": [
                                   {
                                       "Amount": 5,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 60
                               },
                               "FrameDelay": 14,
                               "GarrisonCapacity": 0,
                               "HP": 105,
                               "ID": 1759,
                               "LanguageHelpId": 42104,
                               "LanguageNameId": 21104,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 8,
                               "TraitPiece": 1738,
                               "internal_name": "RATHA2"
                           },
                           "1761": {
                               "AccuracyPercent": 90,
                               "Armours": [
                                   {
                                       "Amount": 2,
                                       "Class": 4
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 8
                                   },
                                   {
                                       "Amount": 1,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 19
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 28
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 31
                                   }
                               ],
                               "Attack": 6,
                               "AttackDelaySeconds": 0.6206666666666667,
                               "Attacks": [
                                   {
                                       "Amount": 6,
                                       "Class": 3
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 15
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 11
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 21
                                   },
                                   {
                                       "Amount": 0,
                                       "Class": 27
                                   }
                               ],
                               "ChargeEvent": 0,
                               "ChargeType": 0,
                               "Cost": {
                                   "Gold": 60,
                                   "Wood": 60
                               },
                               "FrameDelay": 14,
                               "GarrisonCapacity": 0,
                               "HP": 115,
                               "ID": 1761,
                               "LanguageHelpId": 42105,
                               "LanguageNameId": 21105,
                               "LineOfSight": 6,
                               "MaxCharge": 0,
                               "MeleeArmor": 2,
                               "MinRange": 0,
                               "PierceArmor": 1,
                               "Range": 4,
                               "RechargeRate": 0,
                               "ReloadTime": 2,
                               "Speed": 1.3,
                               "TrainTime": 18,
                               "Trait": 8,
                               "TraitPiece": 1740,
                               "internal_name": "ERATHA2"
                           }
                       }
                   },
                   "tech_tree_strings": {
                       "Age of Empires II": "1001",
                       "Building": "300084",
                       "Civilization": "9681",
                       "Key": "300081",
                       "Technology": "300085",
                       "Technology Tree": "9799",
                       "Unique Unit": "300082",
                       "Unit": "300083"
                   },
                   "techtrees": {
                       "Aztecs": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "meso_",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               54,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               380,
                               408,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 460,
                               "castleAgeUniqueUnit": 725,
                               "imperialAgeUniqueTech": 24,
                               "imperialAgeUniqueUnit": 726
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               331,
                               358,
                               422,
                               440,
                               473,
                               492,
                               527,
                               529,
                               532,
                               539,
                               545,
                               548,
                               550,
                               567,
                               588,
                               751,
                               752,
                               753,
                               1103,
                               1104,
                               1105,
                               1258,
                               1570
                           ]
                       },
                       "Bengalis": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               322,
                               373,
                               374,
                               375,
                               377,
                               380,
                               408,
                               435,
                               436,
                               438,
                               441,
                               602,
                               608
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 833,
                               "castleAgeUniqueUnit": 1759,
                               "imperialAgeUniqueTech": 834,
                               "imperialAgeUniqueUnit": 1761
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               331,
                               358,
                               359,
                               420,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               691,
                               873,
                               875,
                               1103,
                               1104,
                               1105,
                               1132,
                               1134,
                               1744,
                               1746
                           ]
                       },
                       "Berbers": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               322,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 578,
                               "castleAgeUniqueUnit": 1007,
                               "imperialAgeUniqueTech": 579,
                               "imperialAgeUniqueUnit": 1009
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1010,
                               1012,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Bohemians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               377,
                               408,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 784,
                               "castleAgeUniqueUnit": 1704,
                               "imperialAgeUniqueTech": 785,
                               "imperialAgeUniqueUnit": 1706
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               529,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1258,
                               1709
                           ]
                       },
                       "Britons": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 3,
                               "castleAgeUniqueUnit": 8,
                               "imperialAgeUniqueTech": 461,
                               "imperialAgeUniqueUnit": 530
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Bulgarians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1251
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               47,
                               48,
                               50,
                               51,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               322,
                               374,
                               377,
                               380,
                               408,
                               435,
                               436,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 685,
                               "castleAgeUniqueUnit": 1225,
                               "imperialAgeUniqueTech": 686,
                               "imperialAgeUniqueUnit": 1227
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               588,
                               1103,
                               1104,
                               1105,
                               1254,
                               1255,
                               1258
                           ]
                       },
                       "Burgundians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               379,
                               408,
                               441,
                               602,
                               608
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 754,
                               "castleAgeUniqueUnit": 1655,
                               "imperialAgeUniqueTech": 755,
                               "imperialAgeUniqueUnit": 1657
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               527,
                               529,
                               532,
                               539,
                               545,
                               546,
                               550,
                               567,
                               569,
                               691,
                               1103,
                               1104,
                               1105,
                               1258,
                               1699
                           ]
                       },
                       "Burmese": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               213,
                               215,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               322,
                               374,
                               375,
                               377,
                               380,
                               408,
                               435,
                               436,
                               438,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 626,
                               "castleAgeUniqueUnit": 1126,
                               "imperialAgeUniqueTech": 627,
                               "imperialAgeUniqueUnit": 1128
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1132,
                               1134,
                               1258
                           ]
                       },
                       "Byzantines": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               322,
                               373,
                               374,
                               375,
                               379,
                               408,
                               437,
                               438,
                               439,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 464,
                               "castleAgeUniqueUnit": 40,
                               "imperialAgeUniqueTech": 61,
                               "imperialAgeUniqueUnit": 553
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               545,
                               546,
                               548,
                               550,
                               567,
                               569,
                               691,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Celts": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 482,
                               "castleAgeUniqueUnit": 232,
                               "imperialAgeUniqueTech": 5,
                               "imperialAgeUniqueUnit": 534
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               569,
                               588,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Chinese": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               380,
                               408,
                               435,
                               437,
                               438,
                               441,
                               602,
                               608
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 462,
                               "castleAgeUniqueUnit": 73,
                               "imperialAgeUniqueTech": 52,
                               "imperialAgeUniqueUnit": 559
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Cumans": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               199,
                               209,
                               276,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               182,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               231,
                               249,
                               252,
                               278,
                               280,
                               315,
                               319,
                               321,
                               322,
                               374,
                               379,
                               380,
                               408,
                               435,
                               436,
                               437,
                               439,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 689,
                               "castleAgeUniqueUnit": 1231,
                               "imperialAgeUniqueTech": 690,
                               "imperialAgeUniqueUnit": 1233
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               331,
                               358,
                               359,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               532,
                               539,
                               545,
                               546,
                               548,
                               550,
                               567,
                               569,
                               588,
                               1103,
                               1104,
                               1105,
                               1258,
                               1370,
                               1372
                           ]
                       },
                       "Dravidians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               249,
                               278,
                               280,
                               315,
                               319,
                               322,
                               373,
                               374,
                               375,
                               379,
                               380,
                               408,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 831,
                               "castleAgeUniqueUnit": 1735,
                               "imperialAgeUniqueTech": 832,
                               "imperialAgeUniqueUnit": 1737
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               331,
                               358,
                               359,
                               420,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               588,
                               691,
                               873,
                               875,
                               1103,
                               1104,
                               1105,
                               1132,
                               1744,
                               1746,
                               1750
                           ]
                       },
                       "Ethiopians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               380,
                               408,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 574,
                               "castleAgeUniqueUnit": 1016,
                               "imperialAgeUniqueTech": 575,
                               "imperialAgeUniqueUnit": 1018
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               529,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               588,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Franks": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               322,
                               374,
                               375,
                               377,
                               379,
                               408,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 83,
                               "castleAgeUniqueUnit": 281,
                               "imperialAgeUniqueTech": 493,
                               "imperialAgeUniqueUnit": 531
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               569,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Goths": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               199,
                               209,
                               276,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               321,
                               322,
                               373,
                               374,
                               380,
                               408,
                               435,
                               438,
                               441
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 16,
                               "castleAgeUniqueUnit": 41,
                               "imperialAgeUniqueTech": 457,
                               "imperialAgeUniqueUnit": 555
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Gurjaras": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               373,
                               374,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 835,
                               "castleAgeUniqueUnit": 1741,
                               "imperialAgeUniqueTech": 836,
                               "imperialAgeUniqueUnit": 1743
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               329,
                               330,
                               331,
                               420,
                               440,
                               441,
                               442,
                               448,
                               473,
                               527,
                               528,
                               529,
                               539,
                               542,
                               545,
                               546,
                               550,
                               873,
                               875,
                               1103,
                               1104,
                               1105,
                               1744,
                               1746,
                               1751,
                               1753,
                               1755
                           ]
                       },
                       "Hindustanis": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1754
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               322,
                               374,
                               377,
                               379,
                               408,
                               435,
                               437,
                               438,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 506,
                               "castleAgeUniqueUnit": 1747,
                               "imperialAgeUniqueTech": 507,
                               "imperialAgeUniqueUnit": 1749
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               207,
                               279,
                               280,
                               329,
                               330,
                               331,
                               358,
                               420,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               539,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1744,
                               1746
                           ]
                       },
                       "Huns": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               182,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               221,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               319,
                               321,
                               322,
                               374,
                               375,
                               408,
                               435,
                               436,
                               437,
                               439,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 483,
                               "castleAgeUniqueUnit": 755,
                               "imperialAgeUniqueTech": 21,
                               "imperialAgeUniqueUnit": 757
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               539,
                               545,
                               546,
                               548,
                               569,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Incas": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "meso_",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               230,
                               231,
                               233,
                               249,
                               278,
                               279,
                               280,
                               315,
                               316,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               437,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 516,
                               "castleAgeUniqueUnit": 879,
                               "imperialAgeUniqueTech": 517,
                               "imperialAgeUniqueUnit": 881
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               185,
                               279,
                               280,
                               331,
                               358,
                               359,
                               422,
                               440,
                               442,
                               473,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               548,
                               550,
                               567,
                               751,
                               752,
                               753,
                               1103,
                               1104,
                               1105,
                               1258,
                               1570
                           ]
                       },
                       "Italians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               322,
                               373,
                               374,
                               375,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 494,
                               "castleAgeUniqueUnit": 866,
                               "imperialAgeUniqueTech": 499,
                               "imperialAgeUniqueUnit": 868
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               492,
                               527,
                               529,
                               532,
                               539,
                               545,
                               546,
                               550,
                               567,
                               691,
                               882,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Japanese": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               322,
                               373,
                               374,
                               375,
                               377,
                               408,
                               435,
                               436,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 484,
                               "castleAgeUniqueUnit": 291,
                               "imperialAgeUniqueTech": 59,
                               "imperialAgeUniqueUnit": 560
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Khmer": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               219,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               321,
                               322,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               435,
                               436,
                               438,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 622,
                               "castleAgeUniqueUnit": 1120,
                               "imperialAgeUniqueTech": 623,
                               "imperialAgeUniqueUnit": 1122
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               691,
                               1103,
                               1104,
                               1105,
                               1132,
                               1134,
                               1258
                           ]
                       },
                       "Koreans": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               322,
                               373,
                               374,
                               375,
                               377,
                               380,
                               408,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 486,
                               "castleAgeUniqueUnit": 827,
                               "imperialAgeUniqueTech": 445,
                               "imperialAgeUniqueUnit": 829
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               529,
                               532,
                               539,
                               545,
                               546,
                               550,
                               567,
                               588,
                               691,
                               831,
                               832,
                               1103,
                               1105,
                               1258
                           ]
                       },
                       "Lithuanians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               322,
                               374,
                               375,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 691,
                               "castleAgeUniqueUnit": 1234,
                               "imperialAgeUniqueTech": 692,
                               "imperialAgeUniqueUnit": 1236
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               532,
                               539,
                               545,
                               546,
                               550,
                               567,
                               569,
                               691,
                               1103,
                               1104,
                               1105,
                               1258,
                               1707
                           ]
                       },
                       "Magyars": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               47,
                               48,
                               50,
                               54,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               435,
                               436,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 514,
                               "castleAgeUniqueUnit": 869,
                               "imperialAgeUniqueTech": 515,
                               "imperialAgeUniqueUnit": 871
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               567,
                               569,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Malay": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1189
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               230,
                               231,
                               233,
                               249,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               380,
                               408,
                               437,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 624,
                               "castleAgeUniqueUnit": 1123,
                               "imperialAgeUniqueTech": 625,
                               "imperialAgeUniqueUnit": 1125
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               550,
                               691,
                               1103,
                               1104,
                               1105,
                               1132,
                               1134,
                               1258
                           ]
                       },
                       "Malians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               230,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               375,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 576,
                               "castleAgeUniqueUnit": 1013,
                               "imperialAgeUniqueTech": 577,
                               "imperialAgeUniqueUnit": 1015
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               420,
                               422,
                               440,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               545,
                               546,
                               550,
                               567,
                               588,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Mayans": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "meso_",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               379,
                               380,
                               408,
                               437,
                               438,
                               439,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 485,
                               "castleAgeUniqueUnit": 763,
                               "imperialAgeUniqueTech": 4,
                               "imperialAgeUniqueUnit": 765
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               331,
                               358,
                               359,
                               422,
                               440,
                               442,
                               473,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               548,
                               550,
                               751,
                               752,
                               753,
                               1103,
                               1104,
                               1105,
                               1258,
                               1570
                           ]
                       },
                       "Mongols": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               319,
                               321,
                               322,
                               373,
                               374,
                               377,
                               379,
                               408,
                               435,
                               436,
                               437,
                               439,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 487,
                               "castleAgeUniqueUnit": 11,
                               "imperialAgeUniqueTech": 6,
                               "imperialAgeUniqueUnit": 561
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               588,
                               1103,
                               1104,
                               1105,
                               1258,
                               1370,
                               1372
                           ]
                       },
                       "Persians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               321,
                               322,
                               374,
                               375,
                               379,
                               380,
                               408,
                               435,
                               436,
                               437,
                               438,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 488,
                               "castleAgeUniqueUnit": 239,
                               "imperialAgeUniqueTech": 7,
                               "imperialAgeUniqueUnit": 558
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               474,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               569,
                               691,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Poles": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1734
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               230,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               321,
                               322,
                               374,
                               377,
                               379,
                               408,
                               435,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 782,
                               "castleAgeUniqueUnit": 1701,
                               "imperialAgeUniqueTech": 783,
                               "imperialAgeUniqueUnit": 1703
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               529,
                               532,
                               539,
                               545,
                               546,
                               548,
                               550,
                               567,
                               1103,
                               1104,
                               1105,
                               1258,
                               1707
                           ]
                       },
                       "Portuguese": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1021
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               219,
                               221,
                               230,
                               231,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               375,
                               377,
                               380,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 572,
                               "castleAgeUniqueUnit": 1001,
                               "imperialAgeUniqueTech": 573,
                               "imperialAgeUniqueUnit": 1003
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               528,
                               529,
                               539,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1004,
                               1006,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Saracens": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               54,
                               55,
                               63,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               322,
                               374,
                               375,
                               377,
                               379,
                               408,
                               435,
                               436,
                               437,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 9,
                               "castleAgeUniqueUnit": 282,
                               "imperialAgeUniqueTech": 454,
                               "imperialAgeUniqueUnit": 556
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               329,
                               330,
                               331,
                               358,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               539,
                               545,
                               546,
                               548,
                               550,
                               567,
                               588,
                               691,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Sicilians": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               199,
                               209,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792,
                               1665
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               182,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               321,
                               322,
                               373,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               435,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 756,
                               "castleAgeUniqueUnit": 1658,
                               "imperialAgeUniqueTech": 757,
                               "imperialAgeUniqueUnit": 1659
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               588,
                               1103,
                               1104,
                               1105,
                               1258,
                               1660,
                               1661
                           ]
                       },
                       "Slavs": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               375,
                               377,
                               379,
                               408,
                               435,
                               438,
                               441,
                               602,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 455,
                               "castleAgeUniqueUnit": 876,
                               "imperialAgeUniqueTech": 513,
                               "imperialAgeUniqueUnit": 878
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               588,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Spanish": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               379,
                               408,
                               435,
                               437,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 492,
                               "castleAgeUniqueUnit": 771,
                               "imperialAgeUniqueTech": 440,
                               "imperialAgeUniqueUnit": 773
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               532,
                               539,
                               545,
                               546,
                               548,
                               550,
                               567,
                               569,
                               691,
                               775,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Tatars": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               47,
                               48,
                               50,
                               54,
                               55,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               230,
                               233,
                               249,
                               252,
                               278,
                               280,
                               315,
                               319,
                               321,
                               322,
                               374,
                               375,
                               377,
                               380,
                               408,
                               435,
                               436,
                               437,
                               441,
                               602
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 687,
                               "castleAgeUniqueUnit": 1228,
                               "imperialAgeUniqueTech": 688,
                               "imperialAgeUniqueUnit": 1230
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               529,
                               532,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               691,
                               1103,
                               1104,
                               1105,
                               1258,
                               1263,
                               1370,
                               1372
                           ]
                       },
                       "Teutons": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               252,
                               278,
                               279,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               374,
                               377,
                               379,
                               380,
                               408,
                               435,
                               438,
                               439,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 489,
                               "castleAgeUniqueUnit": 25,
                               "imperialAgeUniqueTech": 11,
                               "imperialAgeUniqueUnit": 554
                           },
                           "units": [
                               4,
                               5,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               527,
                               528,
                               529,
                               532,
                               539,
                               542,
                               545,
                               550,
                               567,
                               569,
                               588,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Turks": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               231,
                               249,
                               252,
                               278,
                               280,
                               315,
                               316,
                               319,
                               321,
                               322,
                               373,
                               374,
                               375,
                               379,
                               380,
                               408,
                               435,
                               436,
                               437,
                               438,
                               439,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 491,
                               "castleAgeUniqueUnit": 46,
                               "imperialAgeUniqueTech": 10,
                               "imperialAgeUniqueUnit": 557
                           },
                           "units": [
                               4,
                               5,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               329,
                               330,
                               331,
                               420,
                               422,
                               440,
                               441,
                               442,
                               448,
                               473,
                               474,
                               527,
                               528,
                               529,
                               539,
                               542,
                               545,
                               546,
                               548,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1258
                           ]
                       },
                       "Vietnamese": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               235,
                               236,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               15,
                               17,
                               22,
                               23,
                               39,
                               45,
                               47,
                               48,
                               54,
                               55,
                               63,
                               64,
                               65,
                               67,
                               68,
                               74,
                               76,
                               77,
                               80,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               231,
                               233,
                               249,
                               278,
                               279,
                               280,
                               315,
                               319,
                               321,
                               322,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               435,
                               437,
                               438,
                               441,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 628,
                               "castleAgeUniqueUnit": 1129,
                               "imperialAgeUniqueTech": 629,
                               "imperialAgeUniqueUnit": 1131
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               36,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               279,
                               280,
                               283,
                               331,
                               358,
                               359,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               474,
                               492,
                               527,
                               528,
                               529,
                               539,
                               545,
                               546,
                               550,
                               567,
                               691,
                               1103,
                               1104,
                               1105,
                               1132,
                               1134,
                               1155,
                               1258
                           ]
                       },
                       "Vikings": {
                           "buildings": [
                               12,
                               45,
                               49,
                               50,
                               68,
                               70,
                               72,
                               79,
                               82,
                               84,
                               87,
                               101,
                               103,
                               104,
                               109,
                               117,
                               155,
                               199,
                               209,
                               234,
                               276,
                               487,
                               562,
                               584,
                               598,
                               621,
                               792
                           ],
                           "monkPrefix": "",
                           "techs": [
                               8,
                               12,
                               13,
                               14,
                               17,
                               22,
                               23,
                               45,
                               47,
                               48,
                               50,
                               51,
                               54,
                               55,
                               65,
                               67,
                               68,
                               74,
                               75,
                               76,
                               77,
                               81,
                               82,
                               93,
                               101,
                               102,
                               103,
                               140,
                               182,
                               194,
                               199,
                               200,
                               201,
                               202,
                               203,
                               211,
                               212,
                               213,
                               215,
                               219,
                               221,
                               230,
                               249,
                               252,
                               278,
                               280,
                               315,
                               319,
                               321,
                               322,
                               374,
                               375,
                               377,
                               379,
                               380,
                               408,
                               439,
                               602,
                               608,
                               716
                           ],
                           "unique": {
                               "castleAgeUniqueTech": 463,
                               "castleAgeUniqueUnit": 692,
                               "imperialAgeUniqueTech": 49,
                               "imperialAgeUniqueUnit": 694
                           },
                           "units": [
                               4,
                               6,
                               7,
                               13,
                               17,
                               21,
                               24,
                               38,
                               39,
                               74,
                               75,
                               77,
                               83,
                               93,
                               125,
                               128,
                               250,
                               279,
                               280,
                               283,
                               331,
                               358,
                               420,
                               422,
                               440,
                               442,
                               448,
                               473,
                               492,
                               527,
                               528,
                               533,
                               539,
                               542,
                               545,
                               546,
                               548,
                               550,
                               567,
                               691,
                               1104,
                               1105,
                               1258
                           ]
                       }
                   }
               }